import * as FullCalendar from "@fullcalendar/core";
import dayGridPlugin from '@fullcalendar/daygrid';
import ruLocale from '@fullcalendar/core/locales/ru';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';

import { Fancybox } from "@fancyapps/ui/dist/fancybox/";

window.$ = window.jQuery = require('jquery');
import * as FilePond from 'filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';

// Import the plugin styles
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';

/** Включить отладочные логи в консоль */
const DEBUG = false;

/** URL для AJAX (WordPress wp_localize_script или fallback) */
function getAjaxUrl() {
    return (typeof window !== 'undefined' && window.ajaxurl?.url) ? window.ajaxurl.url : '/wp-admin/admin-ajax.php';
}

/** Экранирование строки для безопасной вставки в HTML */
function escapeHtml(str) {
    if (str == null) return '';
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
}

/** Блокировка элемента. Класс block_element — основной; blocked — для совместимости со стилями (.response_wrap). */
function blockEl(selectorOrId, withSpinner = false) {
    const $el = /^[.#]/.test(selectorOrId) ? $(selectorOrId) : $('#' + selectorOrId);
    $el.addClass('block_element blocked');
    if (withSpinner) $el.addClass('with_spinner');
}

function unblockEl(selectorOrId) {
    const $el = /^[.#]/.test(selectorOrId) ? $(selectorOrId) : $('#' + selectorOrId);
    $el.removeClass('block_element blocked with_spinner');
}

/**
 * Показать красивый toast-алерт (вместо alert).
 * @param {string} message - Текст сообщения
 * @param {'success'|'error'|'info'} type - Тип: успех, ошибка, информация
 */
function showAlert(message, type = 'info') {
    if (!message) return;
    const $body = window.$ ? window.$(document.body) : null;
    if (!$body || !$body.length) {
        window.alert(message);
        return;
    }
    const typeClass = type === 'success' ? 'daybooster-alert--success' : type === 'error' ? 'daybooster-alert--error' : 'daybooster-alert--info';
    const $toast = window.$('<div class="daybooster-alert ' + typeClass + '" role="alert">' +
        '<span class="daybooster-alert__text"></span>' +
        '<button type="button" class="daybooster-alert__close" aria-label="Закрыть">&times;</button>' +
        '</div>');
    $toast.find('.daybooster-alert__text').text(message);
    $body.append($toast);
    requestAnimationFrame(function() { $toast.addClass('daybooster-alert--visible'); });
    function remove() {
        $toast.removeClass('daybooster-alert--visible');
        setTimeout(function() { $toast.remove(); }, 300);
    }
    $toast.on('click', '.daybooster-alert__close', remove);
    setTimeout(remove, 4500);
}

/**
 * Подтверждение сохранения дня («Сегодня»): две ветки текста и кнопка «Да, сохранить день».
 * @param {boolean} allTasksDone
 * @param {() => void} onConfirm
 */
function showDaySaveConfirm(allTasksDone, onConfirm) {
    const message = allTasksDone
        ? 'Вы выполнили все дела. День будет сохранён как успешный.'
        : 'Вы хотите сохранить день? У вас остались невыполненные дела. День будет сохранён как неуспешный.';
    const $body = window.$ ? window.$(document.body) : null;
    if (!$body || !$body.length) {
        if (window.confirm(message + '\n\nСохранить день?')) {
            onConfirm();
        }
        return;
    }
    const $overlay = window.$(
        '<div class="daybooster-confirm" role="dialog" aria-modal="true" aria-labelledby="daybooster-confirm-title">' +
        '<div class="daybooster-confirm__backdrop" tabindex="-1"></div>' +
        '<div class="daybooster-confirm__panel">' +
        '<p class="daybooster-confirm__message" id="daybooster-confirm-title"></p>' +
        '<div class="daybooster-confirm__actions">' +
        '<button type="button" class="daybooster_btn daybooster-confirm__btn-cancel">Отмена</button>' +
        '<button type="button" class="daybooster_btn daybooster-confirm__btn-ok">Да, сохранить день</button>' +
        '</div></div></div>'
    );
    $overlay.find('.daybooster-confirm__message').text(message);
    function close() {
        $overlay.remove();
        window.$(document).off('keydown.dayboosterDaySave');
    }
    $overlay.on('click', '.daybooster-confirm__backdrop', close);
    $overlay.on('click', '.daybooster-confirm__btn-cancel', close);
    $overlay.on('click', '.daybooster-confirm__btn-ok', function() {
        close();
        onConfirm();
    });
    $body.append($overlay);
    requestAnimationFrame(function() { $overlay.addClass('daybooster-confirm--visible'); });
    window.$(document).on('keydown.dayboosterDaySave', function(ev) {
        if (ev.key === 'Escape') {
            close();
        }
    });
    const $ok = $overlay.find('.daybooster-confirm__btn-ok');
    if ($ok.length) {
        $ok.trigger('focus');
    }
}

/**
 * Модальное поздравление при завершении программы (после сохранения дня).
 * @param {Array<{title?: string, cap_id?: number, permalink?: string}>} items
 */
function showProgramCompletedCongrats(items) {
    if (!items || !items.length) {
        return;
    }
    const $body = window.$ ? window.$(document.body) : null;
    if (!$body || !$body.length) {
        showAlert(items.map(function(i) { return (i && i.title) ? String(i.title) : ''; }).filter(Boolean).join(', '), 'success');
        return;
    }
    const n = items.length;
    const intro = n === 1
        ? 'Вы завершили программу:'
        : 'Вы завершили программы:';

    const $overlay = window.$(
        '<div class="daybooster-program-complete" role="dialog" aria-modal="true" aria-labelledby="daybooster-pc-title">' +
        '<div class="daybooster-program-complete__backdrop" tabindex="-1"></div>' +
        '<div class="daybooster-program-complete__panel">' +
        '<div class="daybooster-program-complete__icon" aria-hidden="true">🎉</div>' +
        '<h2 class="daybooster-program-complete__title" id="daybooster-pc-title">Поздравляем!</h2>' +
        '<p class="daybooster-program-complete__intro"></p>' +
        '<ul class="daybooster-program-complete__list"></ul>' +
        '<div class="daybooster-program-complete__actions">' +
        '<button type="button" class="daybooster_btn daybooster-program-complete__btn-ok">Супер!</button>' +
        '</div></div></div>'
    );
    $overlay.find('.daybooster-program-complete__intro').text(intro);
    const $ul = $overlay.find('.daybooster-program-complete__list');
    items.forEach(function(it) {
        const $li = window.$('<li class="daybooster-program-complete__item"></li>');
        const title = (it && it.title) ? String(it.title) : '';
        const permalink = (it && it.permalink) ? String(it.permalink) : '';
        if (permalink) {
            $li.append(window.$('<a class="daybooster-program-complete__link"></a>').attr('href', permalink).text(title));
        } else {
            $li.append(window.$('<span class="daybooster-program-complete__name"></span>').text(title));
        }
        $ul.append($li);
    });
    function closePc() {
        $overlay.remove();
        window.$(document).off('keydown.dayboosterProgramComplete');
    }
    $overlay.on('click', '.daybooster-program-complete__backdrop', closePc);
    $overlay.on('click', '.daybooster-program-complete__btn-ok', closePc);
    $body.append($overlay);
    requestAnimationFrame(function() { $overlay.addClass('daybooster-program-complete--visible'); });
    window.$(document).on('keydown.dayboosterProgramComplete', function(ev) {
        if (ev.key === 'Escape') {
            closePc();
        }
    });
    $overlay.find('.daybooster-program-complete__btn-ok').trigger('focus');
}

/**
 * Мягкий оффер Premium после первого успешного сохранённого дня.
 * @param {string} premiumUrl
 */
function showFirstDayPremiumOffer(premiumUrl) {
    if (!premiumUrl) {
        return;
    }
    const $body = window.$ ? window.$(document.body) : null;
    if (!$body || !$body.length) {
        return;
    }
    const $overlay = window.$(
        '<div class="daybooster-program-complete daybooster-first-day-offer" role="dialog" aria-modal="true" aria-labelledby="daybooster-fd-title">' +
        '<div class="daybooster-program-complete__backdrop" tabindex="-1"></div>' +
        '<div class="daybooster-program-complete__panel">' +
        '<h2 class="daybooster-program-complete__title" id="daybooster-fd-title">Первый день закрыт</h2>' +
        '<p class="daybooster-program-complete__intro">Завтра снова будут дела в списке. Premium открывает больше программ и рассылки в Telegram и ВК — когда будете готовы.</p>' +
        '<div class="daybooster-program-complete__actions">' +
        '<a class="daybooster_btn daybooster-program-complete__btn-ok" href="#" data-fd-premium>Смотреть Premium</a>' +
        '<button type="button" class="daybooster_btn sky daybooster-program-complete__btn-later">Позже</button>' +
        '</div></div></div>'
    );
    function closeFd() {
        $overlay.remove();
        window.$(document).off('keydown.dayboosterFirstDayOffer');
    }
    $overlay.on('click', '.daybooster-program-complete__backdrop', closeFd);
    $overlay.on('click', '.daybooster-program-complete__btn-later', closeFd);
    $overlay.on('click', '[data-fd-premium]', function(e) {
        e.preventDefault();
        window.location.href = premiumUrl;
    });
    $body.append($overlay);
    requestAnimationFrame(function() { $overlay.addClass('daybooster-program-complete--visible'); });
    window.$(document).on('keydown.dayboosterFirstDayOffer', function(ev) {
        if (ev.key === 'Escape') {
            closeFd();
        }
    });
}

jQuery(function($){

    // Мобильные WebView: явно шлём cookie на same-origin AJAX (кабинет, отправка расписания на почту).
    $.ajaxSetup({
        xhrFields: { withCredentials: true },
    });

    // Ночной режим: переключение и синхронизация иконок
    function updateDarkModeIcons() {
        var isDark = document.documentElement.classList.contains('theme-dark');
        $('.dark-mode-toggle__icon--moon').toggle(!isDark);
        $('.dark-mode-toggle__icon--sun').toggle(isDark);
    }
    $(document).on('click', '.dark-mode-toggle', function() {
        document.documentElement.classList.toggle('theme-dark');
        var isDark = document.documentElement.classList.contains('theme-dark');
        try { localStorage.setItem('daybooster_theme', isDark ? 'dark' : 'light'); } catch (e) {}
        updateDarkModeIcons();
    });
    updateDarkModeIcons();

    $(".input_change").on('click',function (e) {
        e.preventDefault();
        let input_wrap = $(this).parents(".input_wrap");
        if(!input_wrap.hasClass('edit')){
            input_wrap.addClass('edit');
        }else{
            input_wrap.removeClass('edit');
        }
    })

    const settingsForm = document.getElementById('form_settings');


    FilePond.registerPlugin(
        FilePondPluginImagePreview
    );

    const photoPreviewImg = document.querySelector('.settings_photo__preview img');
    const photoPreviewOriginalSrc = photoPreviewImg ? photoPreviewImg.getAttribute('src') : '';
    let photoPreviewObjectUrl = '';

    const filepondInput = document.querySelector('#form_settings .filepond, .settings_photo .filepond');
    let filepond = filepondInput
        ? FilePond.create(filepondInput, {
            credits: null,
            instantUpload: false,
            allowProcess: false,
            allowImagePreview: false,
            labelIdle: '<span class="filepond--label-action">Выбрать фото</span>',
            styleButtonRemoveItemPosition: 'right',
            onaddfile: (error, fileItem) => {
                if (error || !photoPreviewImg || !fileItem || !fileItem.file) {
                    return;
                }
                if (photoPreviewObjectUrl) {
                    URL.revokeObjectURL(photoPreviewObjectUrl);
                }
                photoPreviewObjectUrl = URL.createObjectURL(fileItem.file);
                photoPreviewImg.src = photoPreviewObjectUrl;
            },
            onremovefile: () => {
                if (photoPreviewObjectUrl) {
                    URL.revokeObjectURL(photoPreviewObjectUrl);
                    photoPreviewObjectUrl = '';
                }
                if (photoPreviewImg && photoPreviewOriginalSrc) {
                    photoPreviewImg.src = photoPreviewOriginalSrc;
                }
            },
        })
        : null;

    $("#update_settings_btn").on('click', function (e) {
        e.preventDefault();
        if (!settingsForm) {
            return;
        }
        let settings_form = new FormData(settingsForm);
        const displayNameEl = document.getElementById('display_name');
        if (displayNameEl) {
            const name = (displayNameEl.value || '').trim();
            if (name.length > 30) {
                showAlert('Имя не должно быть длиннее 30 символов.', 'error');
                return;
            }
        }
        settings_form.append('action', 'updateSettings');
        if (filepond && filepond.getFiles().length > 0) {
            settings_form.append('filepond', filepond.getFiles()[0].file);
        }
        $.ajax({
            url: getAjaxUrl(),
            data: settings_form,
            type: 'POST',
            processData: false,
            contentType: false,
            cache: false,
            beforeSend: function() {
                blockEl('form_settings', true);
            },
            success: function(data) {
                if (data) {
                    const data_arr = JSON.parse(data);
                    if (data_arr?.userdata?.display_name) {
                        $(".display_name").text(data_arr.userdata.display_name);
                    }
                    if (data_arr?.userdata?.photo_src) {
                        $(".cabinet_user_image img").attr('src', data_arr.userdata.photo_src);
                        $(".avatar img").attr('src', data_arr.userdata.photo_src);
                        if (photoPreviewImg) {
                            photoPreviewImg.src = data_arr.userdata.photo_src;
                        }
                        if (photoPreviewObjectUrl) {
                            URL.revokeObjectURL(photoPreviewObjectUrl);
                            photoPreviewObjectUrl = '';
                        }
                        if (filepond) {
                            filepond.removeFile();
                        }
                    }
                    const msg = data_arr?.result ? [data_arr.result.data, data_arr.result.file, data_arr.result.password, data_arr.result.vk].filter(Boolean).join(' ') : '';
                    const isError = (data_arr?.result?.password && data_arr.result.password.indexOf('успешно') === -1) || data_arr?.result?.vk;
                    if (msg) showAlert(msg, isError ? 'error' : 'success');
                    if (data_arr?.result?.password) {
                        $('#current_password, #new_password, #new_password_confirm').val('');
                    }
                }
                unblockEl('form_settings');
            },
            error: function() {
                unblockEl('form_settings');
                showAlert('Произошла ошибка при сохранении настроек.', 'error');
            }
        });
    })



    $(".step_buttons .nav_btn").on('click',function (e) {
        e.preventDefault();
        $(this).parents('.step.active').removeClass('active');
        let need_block = $(this).hasClass('prev') ? $(this).parents('.step').prev('.step') : $(this).parents('.step').next('.step');
        need_block.addClass('active')
    })

    // datetimepicker подключается в assets/index.js (jquery.datetimepicker.full.min)
    const dbPickerOpts = {
        className: 'db-create-datetimepicker',
        scrollMonth: false,
        dayOfWeekStart: 1,
    };
    if (typeof $.datetimepicker !== 'undefined' && typeof $.datetimepicker.setLocale === 'function') {
        $.datetimepicker.setLocale('ru');
    }

    (function initCreateWhenPickers() {
        const form = document.getElementById('questions_form');
        if (!form) {
            return;
        }
        const dbWhenVars = typeof window !== 'undefined' ? window.daybooster_vars : undefined;
        const pad2 = function(n) {
            return (n < 10 ? '0' : '') + n;
        };
        const parseYmd = function(s) {
            const m = String(s || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
            if (!m) {
                return null;
            }
            return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
        };
        const formatYmd = function(d) {
            return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate());
        };
        const monthNames = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
        const monthNamesGen = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
        const weekdays = ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'];
        const dowShort = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];

        const timeInput = document.getElementById('daybooster_wake_up');
        const timeStage = form.querySelector('[data-create-time-stage]');
        if (timeInput && timeStage && !timeStage.getAttribute('data-ready')) {
            timeStage.setAttribute('data-ready', '1');
            let minutes = 7 * 60;
            const parsed = String(timeInput.value || '').match(/^(\d{1,2}):(\d{2})/);
            if (parsed) {
                minutes = Math.min(23, parseInt(parsed[1], 10)) * 60 + Math.min(59, parseInt(parsed[2], 10));
            }
            minutes = Math.round(minutes / 10) * 10;
            if (minutes >= 24 * 60) {
                minutes = 23 * 60 + 50;
            }
            const presets = ['06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '10:00'];
            timeStage.innerHTML =
                '<div class="create-clock">' +
                    '<label class="create-clock__field">' +
                        '<span class="create-clock__field-label">Время начала дня</span>' +
                        '<input type="time" class="create-clock__input" data-clock-input step="600" />' +
                    '</label>' +
                    '<div class="create-when__chips" data-clock-presets></div>' +
                '</div>';
            const visibleTime = timeStage.querySelector('[data-clock-input]');
            const presetsEl = timeStage.querySelector('[data-clock-presets]');
            const timeStr = function() {
                const h = Math.floor(minutes / 60);
                const m = minutes % 60;
                return pad2(h) + ':' + pad2(m);
            };
            const paintTime = function() {
                const t = timeStr();
                timeInput.value = t;
                if (visibleTime) {
                    visibleTime.value = t;
                }
                if (presetsEl) {
                    presetsEl.querySelectorAll('.create-when__chip').forEach(function(btn) {
                        btn.classList.toggle('is-on', btn.getAttribute('data-time') === t);
                    });
                }
            };
            presets.forEach(function(t) {
                const btn = document.createElement('button');
                btn.type = 'button';
                btn.className = 'create-when__chip';
                btn.setAttribute('data-time', t);
                btn.textContent = t;
                presetsEl.appendChild(btn);
            });
            if (visibleTime) {
                visibleTime.addEventListener('change', function() {
                    const p = String(visibleTime.value || '').match(/^(\d{1,2}):(\d{2})/);
                    if (!p) {
                        paintTime();
                        return;
                    }
                    minutes = Math.min(23, parseInt(p[1], 10)) * 60 + Math.min(59, parseInt(p[2], 10));
                    minutes = Math.round(minutes / 10) * 10;
                    if (minutes >= 24 * 60) {
                        minutes = 23 * 60 + 50;
                    }
                    paintTime();
                });
            }
            timeStage.addEventListener('click', function(e) {
                const btn = e.target.closest('button');
                if (!btn || !timeStage.contains(btn) || !btn.hasAttribute('data-time')) {
                    return;
                }
                const p = String(btn.getAttribute('data-time')).match(/^(\d{2}):(\d{2})$/);
                if (p) {
                    minutes = parseInt(p[1], 10) * 60 + parseInt(p[2], 10);
                    paintTime();
                }
            });
            paintTime();
        }

        const dateInput = document.getElementById('daybooster_start_date');
        const dateStage = form.querySelector('[data-create-date-stage]');
        if (dateInput && dateStage && !dateStage.getAttribute('data-ready')) {
            dateStage.setAttribute('data-ready', '1');
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            let minDate = parseYmd(dbWhenVars && dbWhenVars.createMinStartDate);
            if (!minDate) {
                minDate = new Date(today);
                minDate.setDate(today.getDate() + 1);
            }
            minDate.setHours(0, 0, 0, 0);
            let selected = parseYmd(dateInput.value) || new Date(minDate);
            if (selected < minDate) {
                selected = new Date(minDate);
            }
            let view = new Date(selected.getFullYear(), selected.getMonth(), 1);
            dateStage.innerHTML =
                '<div class="create-start">' +
                    '<p class="create-start__summary" aria-live="polite" data-start-summary></p>' +
                    '<div class="create-when__chips" data-start-presets></div>' +
                    '<div class="create-start__cal">' +
                        '<div class="create-start__nav">' +
                            '<button type="button" class="create-start__nav-btn" data-cal-prev aria-label="Предыдущий месяц"></button>' +
                            '<span class="create-start__nav-title" data-cal-title></span>' +
                            '<button type="button" class="create-start__nav-btn create-start__nav-btn--next" data-cal-next aria-label="Следующий месяц"></button>' +
                        '</div>' +
                        '<div class="create-start__grid" data-cal-grid></div>' +
                    '</div>' +
                '</div>';
            const summaryEl = dateStage.querySelector('[data-start-summary]');
            const titleEl = dateStage.querySelector('[data-cal-title]');
            const gridEl = dateStage.querySelector('[data-cal-grid]');
            const presetsEl = dateStage.querySelector('[data-start-presets]');
            const prevBtn = dateStage.querySelector('[data-cal-prev]');
            const addDays = function(base, n) {
                const d = new Date(base);
                d.setDate(d.getDate() + n);
                return d;
            };
            const isSameDay = function(a, b) {
                return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
            };
            const paintHero = function() {
                dateInput.value = formatYmd(selected);
                if (summaryEl) {
                    summaryEl.textContent = weekdays[selected.getDay()] + ', ' + selected.getDate() + ' ' + monthNamesGen[selected.getMonth()];
                }
                if (presetsEl) {
                    presetsEl.querySelectorAll('.create-when__chip').forEach(function(btn) {
                        btn.classList.toggle('is-on', btn.getAttribute('data-ymd') === dateInput.value);
                    });
                }
            };
            const paintCal = function() {
                if (!gridEl || !titleEl) {
                    return;
                }
                titleEl.textContent = monthNames[view.getMonth()] + ' ' + view.getFullYear();
                const minView = new Date(minDate.getFullYear(), minDate.getMonth(), 1);
                if (prevBtn) {
                    prevBtn.disabled = view <= minView;
                }
                gridEl.innerHTML = '';
                dowShort.forEach(function(label) {
                    const el = document.createElement('span');
                    el.className = 'create-start__dow';
                    el.textContent = label;
                    gridEl.appendChild(el);
                });
                const first = new Date(view.getFullYear(), view.getMonth(), 1);
                const pad = first.getDay() === 0 ? 6 : first.getDay() - 1;
                for (let i = 0; i < pad; i++) {
                    const empty = document.createElement('span');
                    empty.className = 'create-start__cell create-start__cell--empty';
                    empty.setAttribute('aria-hidden', 'true');
                    gridEl.appendChild(empty);
                }
                const lastDate = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
                for (let day = 1; day <= lastDate; day++) {
                    const cellDate = new Date(view.getFullYear(), view.getMonth(), day);
                    const disabled = cellDate < minDate;
                    const cell = document.createElement(disabled ? 'span' : 'button');
                    cell.className = 'create-start__cell';
                    cell.textContent = String(day);
                    if (!disabled) {
                        cell.type = 'button';
                        cell.setAttribute('data-ymd', formatYmd(cellDate));
                    } else {
                        cell.classList.add('create-start__cell--off');
                    }
                    if (isSameDay(cellDate, selected)) {
                        cell.classList.add('is-on');
                    }
                    if (isSameDay(cellDate, today)) {
                        cell.classList.add('is-today');
                    }
                    gridEl.appendChild(cell);
                }
            };
            const nextMonday = (function() {
                const d = new Date(today);
                const dow = d.getDay();
                let add = (1 - dow + 7) % 7;
                if (add === 0) {
                    add = 7;
                }
                d.setDate(d.getDate() + add);
                d.setHours(0, 0, 0, 0);
                if (d < minDate) {
                    d.setDate(d.getDate() + 7);
                }
                return d;
            })();
            const chipDefs = [
                {
                    ymd: formatYmd(minDate),
                    label: isSameDay(minDate, today)
                        ? 'Сегодня'
                        : (isSameDay(minDate, addDays(today, 1)) ? 'Завтра' : 'Ближайший день')
                },
                {
                    ymd: formatYmd(addDays(minDate, 1)),
                    label: isSameDay(minDate, today) ? 'Завтра' : 'Послезавтра'
                }
            ];
            const mondayYmd = formatYmd(nextMonday);
            if (mondayYmd !== chipDefs[0].ymd && mondayYmd !== chipDefs[1].ymd) {
                chipDefs.push({ ymd: mondayYmd, label: 'Со следующего понедельника' });
            }
            chipDefs.forEach(function(def) {
                const btn = document.createElement('button');
                btn.type = 'button';
                btn.className = 'create-when__chip';
                btn.setAttribute('data-ymd', def.ymd);
                btn.textContent = def.label;
                presetsEl.appendChild(btn);
            });
            dateStage.addEventListener('click', function(e) {
                const btn = e.target.closest('button');
                if (!btn || !dateStage.contains(btn)) {
                    return;
                }
                if (btn.hasAttribute('data-cal-prev')) {
                    view = new Date(view.getFullYear(), view.getMonth() - 1, 1);
                    paintCal();
                    return;
                }
                if (btn.hasAttribute('data-cal-next')) {
                    view = new Date(view.getFullYear(), view.getMonth() + 1, 1);
                    paintCal();
                    return;
                }
                const ymd = btn.getAttribute('data-ymd');
                const d = ymd ? parseYmd(ymd) : null;
                if (d && d >= minDate) {
                    selected = d;
                    view = new Date(selected.getFullYear(), selected.getMonth(), 1);
                    paintHero();
                    paintCal();
                }
            });
            paintHero();
            paintCal();
        }
    })();

    $('.timepicker').datetimepicker($.extend({}, dbPickerOpts, {
        datepicker: false,
        format: 'H:i',
        step: 10,
    }));
    const datepickerOpts = $.extend({}, dbPickerOpts, {
        timepicker: false,
        // ISO-дата: PHP DateTimeImmutable понимает без локали (в отличие от «22 Мар 2025»).
        format: 'Y-m-d',
    });
    const dbVars = typeof window !== 'undefined' ? window.daybooster_vars : undefined;
    if (dbVars && dbVars.createRestrictStartToToday && dbVars.createMinStartDate) {
        datepickerOpts.minDate = dbVars.createMinStartDate;
    }
    $('.datepicker').datetimepicker(datepickerOpts);



    let response = $(".step_response");
    function add_response_item(text, classname = '') {
        const safeClass = escapeHtml(String(classname));
        const safeText = escapeHtml(String(text == null ? '' : text));
        response.find('.step_response_inner').append("<div class='step_response_item " + safeClass + "'>" + safeText + "</div>");
    }
    const form = document.getElementById("questions_form");

    $(".send_daybooster").on('click', function (e) {
        e.preventDefault();
        const $btn = $(this);
        if ($btn.hasClass('is-busy')) {
            return;
        }
        $btn.addClass('is-busy').attr('aria-busy', 'true');

        response.fadeIn(500);
        add_response_item('Сбор и подготовка ваших данных');
        let step_form = new FormData(form);
        step_form.append('action', 'send_questions');
        step_form.append('cap_id', form.getAttribute('data-daybooster'));

        function unlockSendDaybooster() {
            $btn.removeClass('is-busy').attr('aria-busy', 'false');
        }

        $.ajax({
            url: getAjaxUrl(),
            data: step_form,
            processData: false,
            contentType: false,
            type: 'POST',
            cache: false,
            beforeSend: function() {
                $(".step_response_inner").children().remove();
                add_response_item('Отправка ваших данных в Daybooster');
            },
            success: function(data) {
                if (!data) {
                    add_response_item('Пустой ответ сервера');
                    unlockSendDaybooster();
                    return;
                }
                let data_arr;
                try {
                    data_arr = JSON.parse(data);
                } catch (err) {
                    add_response_item('Ошибка разбора ответа');
                    unlockSendDaybooster();
                    return;
                }
                if (data_arr.success === false) {
                    add_response_item(data_arr.message || 'Не удалось добавить программу', 'step_response_item--error');
                    unlockSendDaybooster();
                    return;
                }
                if (typeof window.dayboosterTrack === 'function') {
                    var capId = form.getAttribute('data-daybooster');
                    window.dayboosterTrack('db_add_program', capId ? { program_id: String(capId) } : {});
                }
                add_response_item('Ваши данные обработаны');
                if (data_arr.result) {
                    add_response_item('Получен результат', 'step_response_subtitle');
                    for (const key in data_arr.result) {
                        if (!Object.prototype.hasOwnProperty.call(data_arr.result, key)) continue;
                        add_response_item(key + ": " + data_arr.result[key]);
                    }
                }
                const todayUrl = (typeof window !== 'undefined' && window.daybooster_vars?.todayUrl) ? window.daybooster_vars.todayUrl : '';
                if (todayUrl) {
                    add_response_item('Переход на страницу «Сегодня»…', 'step_response_redirect');
                    window.location.href = todayUrl;
                    return;
                }
                unlockSendDaybooster();
            },
            error: function (xhr) {
                const st = xhr && typeof xhr.status !== 'undefined' ? xhr.status : '';
                const hint = st ? ' (код ' + st + ')' : '';
                add_response_item('Сеть или сервер: не удалось выполнить запрос' + hint + '. Обновите страницу или попробуйте позже.', 'step_response_item--error');
                unlockSendDaybooster();
            }
        });
    })





    $(".remove_single").on('click', function (e) {
        e.preventDefault();
        const approve = $(this).attr('data-approve');
        if (confirm(approve)) {
            $.ajax({
                url: getAjaxUrl(),
                data: { cap_id: $(this).attr('data-cap'), action: 'single_delete' },
                type: 'POST',
                success: function(data) {
                    if (data) {
                        const data_arr = JSON.parse(data);
                        if (data_arr?.result) {
                            for (const key in data_arr.result) showAlert(key + ": " + data_arr.result[key], 'info');
                        }
                        location.reload();
                    }
                },
                error: function() {
                    showAlert('Произошла ошибка при удалении.', 'error');
                }
            });
        }
    })




    $(".delete_all").on('click', function (e) {
        e.preventDefault();
        const approve = $(this).attr('data-approve');
        if (confirm(approve)) {
            $.ajax({
                url: getAjaxUrl(),
                data: { action: 'delete_all' },
                type: 'POST',
                success: function(data) {
                    if (data) {
                        const data_arr = JSON.parse(data);
                        if (data_arr?.result) {
                            for (const key in data_arr.result) showAlert(key + ": " + data_arr.result[key], 'info');
                        }
                        location.reload();
                    }
                },
                error: function() {
                    showAlert('Произошла ошибка при удалении.', 'error');
                }
            });
        }
    })

})



document.addEventListener('DOMContentLoaded', function() {

    const STORAGE_PREFIX = 'daybooster_done_';

    /** Форматировать Date в YYYY-MM-DD для ключа localStorage */
    function formatDateKey(date) {
        if (!(date instanceof Date)) date = new Date(date);
        return date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
    }

    /** Добавить дни к YYYY-MM-DD и вернуть YYYY-MM-DD */
    function addDaysToDateKey(dateStr, days) {
        if (!dateStr) return dateStr;
        const d = new Date(dateStr + 'T00:00:00');
        if (isNaN(d.getTime())) return dateStr;
        d.setDate(d.getDate() + (days || 0));
        return formatDateKey(d);
    }

    /** Карта выполненных дел на дату: { eventId: true }. dateStr — YYYY-MM-DD отображаемого дня. */
    function getDoneMap(dateStr) {
        if (!dateStr) return {};
        try {
            const key = STORAGE_PREFIX + dateStr;
            const raw = localStorage.getItem(key);
            return raw ? JSON.parse(raw) : {};
        } catch (e) {
            return {};
        }
    }

    function setDoneMap(dateStr, map) {
        if (!dateStr) return;
        try {
            localStorage.setItem(STORAGE_PREFIX + dateStr, JSON.stringify(map));
        } catch (e) {
            if (DEBUG) console.error('localStorage setItem failed', e);
        }
    }

    /**
     * Проверка, попадает ли событие календаря на конкретную дату.
     * endRecur в FullCalendar считается не включительно.
     * @param {{startRecur?: string, endRecur?: string, daysOfWeek?: number[]}} ev
     * @param {string} dateStr YYYY-MM-DD
     */
    function occursOnDate(ev, dateStr) {
        if (!ev || !dateStr) return false;
        const date = new Date(dateStr + 'T00:00:00');
        if (isNaN(date.getTime())) return false;
        const dow = date.getDay(); // 0 (Sun) - 6 (Sat)
        const days = Array.isArray(ev.daysOfWeek) ? ev.daysOfWeek : [];
        if (days.length && !days.includes(dow)) return false;
        if (ev.startRecur && dateStr < ev.startRecur) return false;
        if (ev.endRecur && dateStr >= ev.endRecur) return false;
        return true;
    }

    /** Загрузка событий календаря (асинхронно) */
    function getEventsAll() {
        return new Promise(function(resolve, reject) {
            $.ajax({
                url: getAjaxUrl(),
                data: { action: 'get_events_all' },
                type: 'POST',
                cache: false,
                success: function(data) {
                    // После wp_send_json() jQuery может вернуть уже распарсенный объект.
                    resolve(data || { response: 0 });
                },
                error: function() {
                    reject(new Error('Не удалось загрузить события'));
                }
            });
        });
    }

    /**
     * Как daybooster_user_meta_cap_id() в PHP: cap_id из ACF может быть числом, строкой или { ID }.
     * @param {*} value
     * @returns {number}
     */
    function dayboosterNormalizeCapIdToInt(value) {
        if (typeof value === 'number' && !isNaN(value)) {
            return Math.trunc(value);
        }
        if (typeof value === 'string' && value.trim() !== '') {
            const n = parseInt(value, 10);
            return !isNaN(n) ? n : 0;
        }
        if (value && typeof value === 'object' && value.ID != null) {
            const n = parseInt(String(value.ID), 10);
            return !isNaN(n) ? n : 0;
        }
        return 0;
    }

    /**
     * Как $cap_part в daybooster_calendar_event_dom_id() (today-pdf.php) — иначе done_map и PDF не совпадают с сервером.
     * @param {object} entry строка user_caps
     * @param {number} capIdx индекс в массиве
     */
    function dayboosterCalendarCapPart(entry, capIdx) {
        let capRef = entry.cap_id !== undefined ? entry.cap_id : null;
        if (capRef === null || capRef === '') {
            capRef = entry.id !== undefined ? entry.id : null;
        }
        if (capRef === null || capRef === '') {
            return capIdx;
        }
        const rid = dayboosterNormalizeCapIdToInt(capRef);
        return rid > 0 ? rid : capIdx;
    }

    function buildEventsForRender(events) {
        let output_arr = events;
        if (typeof events === 'string') {
            try {
                output_arr = JSON.parse(events);
            } catch (e) {
                output_arr = { response: 0 };
            }
        }
        const eventsForRender = [];
        let userCaps = output_arr.user_caps;
        if (userCaps && !Array.isArray(userCaps) && typeof userCaps === 'object') {
            userCaps = Object.keys(userCaps).sort(function(a, b) { return Number(a) - Number(b); }).map(function(k) { return userCaps[k]; });
        }
        if (output_arr.response != 0 && userCaps && Array.isArray(userCaps)) {
            userCaps.forEach(function(entry, capIdx) {
                let cap_body = entry.cap_body;
                if (typeof cap_body === 'string') {
                    try {
                        cap_body = JSON.parse(entry.cap_body);
                    } catch (e) {
                        cap_body = {};
                    }
                }
                //console.log(cap_body.events)
                (cap_body.events || []).forEach(function(ev, evIdx) {
                    const todayKey = formatDateKey(new Date());
                    if (ev.startDay && ev.startDay > todayKey) {
                        return;
                    }
                    const endDay = (ev.endDay && ev.endDay > todayKey) ? todayKey : ev.endDay;
                    const capPart = dayboosterCalendarCapPart(entry, capIdx);
                    const eventId = [capPart, ev.startDay || '', ev.startTime || '', ev.name || ''].join('_').replace(/[^a-zA-Z0-9_-]/g, '_');
                    const randomColor = '#' + Math.floor(Math.random() * 0xFFFFFF).toString(16).padStart(6, '0');
                    const actionUrl = (ev.actionLink && String(ev.actionLink).trim()) ? String(ev.actionLink).trim() : '';
                    eventsForRender.push({
                        id: eventId,
                        title: ev.name,
                        startRecur: ev.startDay,
                        // FullCalendar считает endRecur не включительно.
                        // На бэкенде endDay обычно формируется как "включительно",
                        // поэтому добавляем +1 день, чтобы последний день попадал в диапазон.
                        endRecur: endDay ? addDaysToDateKey(endDay, 1) : endDay,
                        startTime: ev.startTime,
                        endTime: ev.endTime,
                        backgroundColor: randomColor,
                        daysOfWeek: ev.week_days,
                        // Без url: переход к материалу — только из карточек под календарём (PHP), не из FullCalendar.
                        action: actionUrl,
                        image: ev.image || '',
                        extendedProps: {
                            action: actionUrl,
                            image: ev.image || ''
                        }
                    });
                });
            });
        }
        return eventsForRender;
    }

    /** Превью по URL: ключ в ответе может отличаться слэшем/нормализацией. */
    function findActionPreviewByUrl(items, requestedUrl) {
        if (!items || typeof items !== 'object') return {};
        const u = String(requestedUrl || '');
        if (items[u]) return items[u];
        const noSlash = u.replace(/\/+$/, '');
        if (items[noSlash]) return items[noSlash];
        const withSlash = noSlash ? (noSlash + '/') : '';
        if (withSlash && items[withSlash]) return items[withSlash];
        const keys = Object.keys(items);
        for (let i = 0; i < keys.length; i++) {
            const k = keys[i];
            if (String(k).replace(/\/+$/, '') === noSlash) return items[k];
        }
        return {};
    }

    /**
     * Рендер списка связанных action под календарём.
     * Требование: показываем только те action, которые относятся к делам на конкретную дату.
     * @param {Array} eventsForRender
     * @param {string} dateStr YYYY-MM-DD
     */
    function renderCalendarEventListForDate(eventsForRender, dateStr) {
        const $eventList = $("#calendar_eventList .calendar_events");
        if (!$eventList.length) return;
        $eventList.empty();

        // У каждого интервала своё событие (id); раньше дедуп по URL скрывало «Занятие 2/3» при общей ссылке.
        const seen = new Set();
        const list = [];
        (Array.isArray(eventsForRender) ? eventsForRender : []).forEach(function(ev) {
            if (!ev || !ev.action) return;
            if (!occursOnDate(ev, dateStr)) return;

            const url = String(ev.action || '');
            if (!url || seen.has(ev.id)) return;
            seen.add(ev.id);

            list.push({
                url: url,
                title: String(ev.title || ''),
                image: String(ev.image || '')
            });
        });

        if (!list.length) return;

        // Подтянем short_text/content для action одним запросом.
        $.ajax({
            url: getAjaxUrl(),
            type: 'POST',
            data: {
                action: 'daybooster_get_action_previews',
                urls: list.map(function(x) { return x.url; })
            },
            success: function(resp) {
                let data = resp;
                if (typeof resp === 'string') {
                    try { data = JSON.parse(resp); } catch (e) {}
                }
                const items = (data && data.items) ? data.items : {};

                list.forEach(function(it) {
                    const previewObj = findActionPreviewByUrl(items, it.url);
                    const text = (previewObj.short_text && String(previewObj.short_text).trim())
                        ? String(previewObj.short_text).trim()
                        : (previewObj.content ? String(previewObj.content).trim() : '');

                    const safeUrl = escapeHtml(it.url);
                    const imgSrc = escapeHtml(it.image || '');
                    const name = escapeHtml(it.title || '');
                    const desc = escapeHtml(text || '');
                    const imageHtml = imgSrc ? '<div class="calendar_event_image"><img src="' + imgSrc + '" alt="" /></div>' : '';

                    $eventList.append(
                        '<a target="_blank" rel="noopener" href="' + safeUrl + '" class="calendar_event">' +
                        imageHtml +
                        '<div class="calendar_event_body">' +
                        '<div class="calendar_event_title">' + name + '</div>' +
                        (desc ? '<div class="calendar_event_desc">' + desc + '</div>' : '') +
                        '</div>' +
                        '</a>'
                    );
                });
            },
            error: function() {
                // Фоллбек: если превью не удалось получить — покажем хотя бы карточки без текста.
                list.forEach(function(it) {
                    const safeUrl = escapeHtml(it.url);
                    const imgSrc = escapeHtml(it.image || '');
                    const name = escapeHtml(it.title || '');
                    const imageHtml = imgSrc ? '<div class="calendar_event_image"><img src="' + imgSrc + '" alt="" /></div>' : '';
                    $eventList.append(
                        '<a target="_blank" rel="noopener" href="' + safeUrl + '" class="calendar_event">' +
                        imageHtml +
                        '<div class="calendar_event_body">' +
                        '<div class="calendar_event_title">' + name + '</div>' +
                        '</div></a>'
                    );
                });
            }
        });
    }

    const calendarContainers = document.getElementsByClassName('calendar');
    if (calendarContainers.length > 0) {
        const calendarDayEl = document.getElementById('calendar_today');
        const calendarTomorrowEl = document.getElementById('calendar_tomorrow');
        const calendarWeekEl = document.getElementById('calendar_week');
        const calendarMonthEl = document.getElementById('calendar_month');
        getEventsAll()
            .then(function(events) {
                console.log(events)
                const eventsForRender = buildEventsForRender(events);

                if (calendarDayEl) {
                    // Список под календарём «Сегодня» рендерится в PHP (WP_Query + short_text), см. Today.php.
                    const todayListHost = document.getElementById('calendar_eventList');
                    if (!todayListHost || todayListHost.getAttribute('data-daybooster-server-list') !== '1') {
                        renderCalendarEventListForDate(eventsForRender, formatDateKey(new Date()));
                    }

                    const todayIsAccordion = calendarDayEl.getAttribute('data-daybooster-accordion') === '1';
                    let todayDayLocked = false;
                    /** День уже есть в daybooster_days (для PDF и подсказки администратора). */
                    let todaySavedOnServer = false;

                    function applyLocalDoneMapToToday() {
                        const todayStr = formatDateKey(new Date());
                        const dm = getDoneMap(todayStr);
                        calendarDayEl.querySelectorAll('.event-todo-wrapper').forEach(function(w) {
                            const id = w.getAttribute('data-event-id');
                            if (!id) {
                                return;
                            }
                            const done = !!dm[id];
                            w.classList.toggle('event-done', done);
                            const cb = w.querySelector('.calendar-done-checkbox');
                            if (cb) {
                                cb.checked = done;
                            }
                        });
                    }

                    function initTodayTaskAccordion() {
                        calendarDayEl.querySelectorAll('.calendar_event').forEach(function(card) {
                            card.classList.remove('is-open');
                            const toggle = card.querySelector('.calendar_event_toggle');
                            if (toggle && toggle.tagName === 'BUTTON') {
                                toggle.setAttribute('aria-expanded', 'false');
                            }
                            const panel = card.querySelector('.calendar_event_panel');
                            if (panel) {
                                panel.hidden = true;
                            }
                        });
                        calendarDayEl.addEventListener('click', function(e) {
                            if (e.target.closest('.calendar-done-checkbox') || e.target.closest('.event-todo-wrapper')) {
                                return;
                            }
                            const btn = e.target.closest('.calendar_event_toggle');
                            if (!btn || btn.classList.contains('calendar_event_toggle--static') || btn.tagName !== 'BUTTON') {
                                return;
                            }
                            e.preventDefault();
                            const card = btn.closest('.calendar_event');
                            if (!card) {
                                return;
                            }
                            const open = !card.classList.contains('is-open');
                            card.classList.toggle('is-open', open);
                            btn.setAttribute('aria-expanded', open ? 'true' : 'false');
                            const panel = card.querySelector('.calendar_event_panel');
                            if (panel) {
                                panel.hidden = !open;
                            }
                        });
                    }
                    const allowTodayResave = typeof window.daybooster_vars !== 'undefined' && !!window.daybooster_vars.allowTodayResave;
                    /** Инкремент при перезагрузке статусов после сохранения — отбрасываем устаревшие ответы AJAX. */
                    let todayProgressFetchId = 0;

                    function updateDayProgressFromDom() {
                        const progressEl = document.getElementById('day_progress');
                        if (!progressEl) return;
                        const wrappers = calendarDayEl.querySelectorAll('.event-todo-wrapper');
                        const total = wrappers.length;
                        const done = Array.prototype.filter.call(wrappers, function(w) {
                            return w.classList.contains('event-done');
                        }).length;
                        const valueEl = document.getElementById('day_progress_value');
                        const barEl = document.getElementById('day_progress_bar');
                        const hintEl = document.getElementById('day_progress_hint');
                        let percent = 0;
                        if (total > 0) {
                            percent = Math.round((done / total) * 100);
                        }
                        if (valueEl) valueEl.textContent = percent + '%';
                        if (barEl) barEl.style.width = percent + '%';
                        if (hintEl) {
                            if (todayDayLocked) {
                                hintEl.textContent = 'День уже сохранён. Отметки и повторное сохранение недоступны.';
                            } else if (allowTodayResave && todaySavedOnServer) {
                                hintEl.textContent = 'День сохранён. Как администратор, вы можете менять отметки и пересохранить день.';
                            } else if (!total) {
                                hintEl.textContent = 'На сегодня пока нет дел.';
                            } else if (percent === 100) {
                                hintEl.textContent = 'Все дела на сегодня выполнены. Отличная работа!';
                            } else {
                                hintEl.textContent = 'Отметьте выполненные дела, чтобы завершить день.';
                            }
                        }

                        // Если на сегодня нет активных дел — скрываем кнопку «Сохранить день»,
                        // чтобы нельзя было сохранить день как «неуспешный» без задач.
                        const daySaveBlock = document.querySelector('.day-save');
                        const daySaveStatus = document.getElementById('day_save_status');
                        const todayDateStr = formatDateKey(new Date());
                        const hasEventsToday = Array.isArray(eventsForRender) && eventsForRender.some(function(ev) {
                            return occursOnDate(ev, todayDateStr);
                        });
                        if (daySaveBlock) {
                            daySaveBlock.style.display = (hasEventsToday || todayDayLocked || todaySavedOnServer) ? '' : 'none';
                        }
                        if (!hasEventsToday && !todayDayLocked && !todaySavedOnServer && daySaveStatus) {
                            daySaveStatus.textContent = '';
                            daySaveStatus.classList.remove('day-save__status--success', 'day-save__status--fail', 'day-save__status--error');
                        }
                    }

                    function lockTodayUI() {
                        todaySavedOnServer = true;
                        const pdfWrap = document.getElementById('day_pdf_wrap');
                        if (pdfWrap) {
                            pdfWrap.removeAttribute('hidden');
                        }
                        if (allowTodayResave) {
                            todayDayLocked = false;
                            const btnAdmin = document.getElementById('day_save_btn');
                            if (btnAdmin) {
                                btnAdmin.disabled = false;
                                btnAdmin.textContent = 'Пересохранить день';
                            }
                            if (calendarDayEl) {
                                calendarDayEl.classList.add('calendar--day-saved');
                                calendarDayEl.querySelectorAll('.calendar-done-checkbox').forEach(function(cb) {
                                    cb.disabled = false;
                                });
                            }
                        } else {
                            todayDayLocked = true;
                            const btn = document.getElementById('day_save_btn');
                            if (btn) {
                                btn.disabled = true;
                                btn.textContent = 'День сохранён';
                            }
                            if (calendarDayEl) {
                                calendarDayEl.classList.add('calendar--day-saved');
                                calendarDayEl.querySelectorAll('.calendar-done-checkbox').forEach(function(cb) {
                                    cb.disabled = true;
                                });
                            }
                        }
                        updateDayProgressFromDom();
                    }

                    function unlockTodayUI() {
                        todayDayLocked = false;
                        todaySavedOnServer = false;
                        const btn = document.getElementById('day_save_btn');
                        if (btn) {
                            btn.disabled = false;
                            btn.textContent = 'Сохранить день';
                        }
                        const pdfWrap = document.getElementById('day_pdf_wrap');
                        if (pdfWrap) {
                            pdfWrap.setAttribute('hidden', '');
                        }
                        if (calendarDayEl) {
                            calendarDayEl.classList.remove('calendar--day-saved');
                            calendarDayEl.querySelectorAll('.calendar-done-checkbox').forEach(function(cb) {
                                cb.disabled = false;
                            });
                        }
                        updateDayProgressFromDom();
                    }

                    function applyTodaySavedFromServer(map, aggregates, fetchId) {
                        if (fetchId !== todayProgressFetchId) {
                            return;
                        }
                        const todayStr = formatDateKey(new Date());
                        const st = (map && typeof map === 'object') ? map[todayStr] : undefined;
                        const fromMap = st === 'success' || st === 'fail';
                        const fromAgg = aggregates && aggregates.today_saved === true;
                        if (fromMap || fromAgg) {
                            lockTodayUI();
                        } else if (st === undefined && (!aggregates || aggregates.today_saved !== true)) {
                            unlockTodayUI();
                        }
                    }

                    /**
                     * Восстановить галочки с сервера (done_maps) для уже сохранённого сегодняшнего дня.
                     * @returns {'applied'|'mismatch'|'skipped'}
                     */
                    function hydrateTodayDoneFromServer(map, doneMaps) {
                        const todayStr = formatDateKey(new Date());
                        const st = map && typeof map === 'object' ? map[todayStr] : undefined;
                        if (!doneMaps || typeof doneMaps !== 'object' || !doneMaps[todayStr]) {
                            return 'skipped';
                        }
                        if (st !== 'success' && st !== 'fail') {
                            return 'skipped';
                        }
                        const dm = doneMaps[todayStr];
                        if (!dm || typeof dm !== 'object') {
                            return 'skipped';
                        }
                        const wrappers = calendarDayEl.querySelectorAll('.event-todo-wrapper');
                        let matched = 0;
                        wrappers.forEach(function(w) {
                            if (w.getAttribute('data-date') !== todayStr) {
                                return;
                            }
                            const id = w.getAttribute('data-event-id');
                            if (id && Object.prototype.hasOwnProperty.call(dm, id)) {
                                matched += 1;
                            }
                        });
                        if (matched === 0 && wrappers.length > 0) {
                            return 'mismatch';
                        }
                        setDoneMap(todayStr, dm);
                        wrappers.forEach(function(w) {
                            if (w.getAttribute('data-date') !== todayStr) {
                                return;
                            }
                            const id = w.getAttribute('data-event-id');
                            if (!id) {
                                return;
                            }
                            const done = !!dm[id];
                            w.classList.toggle('event-done', done);
                            const cb = w.querySelector('.calendar-done-checkbox');
                            if (cb) {
                                cb.checked = done;
                            }
                        });
                        updateDayProgressFromDom();
                        return 'applied';
                    }

                    if (todayIsAccordion) {
                        applyLocalDoneMapToToday();
                        initTodayTaskAccordion();
                        setTimeout(updateDayProgressFromDom, 0);
                    } else {
                    const calendarDayInstance = new FullCalendar.Calendar(calendarDayEl, {
                        plugins: [listPlugin],
                        initialView: 'listDay',
                        locales: ruLocale,
                        locale: 'ru',
                        editable: true,
                        events: eventsForRender,
                        headerToolbar:{
                            end:""
                        },
                        eventContent: function(arg) {
                            const eventId = arg.event.id || ('ev_' + (arg.event.title || '') + '_' + (arg.event.startTime || ''));
                            const start = arg.event.start;
                            const dateStr = start ? formatDateKey(start) : formatDateKey(new Date());
                            const doneMap = getDoneMap(dateStr);
                            const isDone = !!doneMap[eventId];
                            const wrapper = document.createElement('div');
                            wrapper.className = 'event-todo-wrapper' + (isDone ? ' event-done' : '');
                            wrapper.setAttribute('data-event-id', eventId);
                            wrapper.setAttribute('data-date', dateStr);
                            const checkbox = document.createElement('input');
                            checkbox.type = 'checkbox';
                            checkbox.className = 'calendar-done-checkbox';
                            checkbox.setAttribute('data-event-id', eventId);
                            checkbox.checked = isDone;
                            checkbox.title = 'Дело сделано';
                            if (todayDayLocked) {
                                checkbox.disabled = true;
                            }
                            const label = document.createElement('span');
                            label.className = 'event-todo-title';
                            label.textContent = arg.event.title || '';
                            wrapper.appendChild(checkbox);
                            wrapper.appendChild(label);
                            // Небольшая задержка, чтобы DOM успел отрисоваться, затем обновим прогресс
                            setTimeout(updateDayProgressFromDom, 0);
                            return { domNodes: [wrapper] };
                        }
                    });
                    calendarDayInstance.render();

                    // начальный пересчёт после первой полной отрисовки
                    setTimeout(updateDayProgressFromDom, 50);
                    }

                    const saveBtn = document.getElementById('day_save_btn');
                    const saveStatus = document.getElementById('day_save_status');
                    const timelineEl = document.getElementById('days_timeline');
                    const weekSummaryEl = document.getElementById('week_summary');
                    const weekSummaryValueEl = document.getElementById('week_summary_value');
                    const weekSummaryHintEl = document.getElementById('week_summary_hint');
                    let todayCalMap = {};
                    let todayCalLeft = null;
                    let todayCalNavBound = false;
                    const todayCalMonthNames = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];

                    function todayCalMonthStart(date) {
                        return new Date(date.getFullYear(), date.getMonth(), 1);
                    }

                    function todayCalAddMonths(date, delta) {
                        return new Date(date.getFullYear(), date.getMonth() + delta, 1);
                    }

                    function todayCalMonthIndex(date) {
                        return date.getFullYear() * 12 + date.getMonth();
                    }

                    function todayCalLimits() {
                        const now = new Date();
                        return {
                            minLeft: todayCalAddMonths(todayCalMonthStart(now), -12),
                            maxLeft: todayCalAddMonths(todayCalMonthStart(now), -1),
                            todayKey: formatDateKey(now)
                        };
                    }

                    function todayCalRange() {
                        const lim = todayCalLimits();
                        const end = new Date();
                        return {
                            start: formatDateKey(lim.minLeft),
                            end: formatDateKey(end)
                        };
                    }

                    function updateTodayCalNav() {
                        if (!todayCalLeft) {
                            return;
                        }
                        const lim = todayCalLimits();
                        const prev = document.getElementById('today_cal_prev');
                        const next = document.getElementById('today_cal_next');
                        if (prev) {
                            prev.disabled = todayCalMonthIndex(todayCalLeft) <= todayCalMonthIndex(lim.minLeft);
                        }
                        if (next) {
                            next.disabled = todayCalMonthIndex(todayCalLeft) >= todayCalMonthIndex(lim.maxLeft);
                        }
                    }

                    function shiftTodayCal(delta) {
                        if (!todayCalLeft) {
                            return;
                        }
                        const lim = todayCalLimits();
                        const next = todayCalAddMonths(todayCalLeft, delta);
                        if (todayCalMonthIndex(next) < todayCalMonthIndex(lim.minLeft) || todayCalMonthIndex(next) > todayCalMonthIndex(lim.maxLeft)) {
                            return;
                        }
                        todayCalLeft = next;
                        paintTodayCalendar();
                    }

                    function bindTodayCalNav() {
                        if (todayCalNavBound) {
                            return;
                        }
                        todayCalNavBound = true;
                        const prev = document.getElementById('today_cal_prev');
                        const next = document.getElementById('today_cal_next');
                        if (prev) {
                            prev.addEventListener('click', function() {
                                shiftTodayCal(-1);
                            });
                        }
                        if (next) {
                            next.addEventListener('click', function() {
                                shiftTodayCal(1);
                            });
                        }
                        if (timelineEl) {
                            timelineEl.addEventListener('click', function(e) {
                                const btn = e.target.closest('.today-cal__cell--open');
                                if (!btn) {
                                    return;
                                }
                                const date = btn.getAttribute('data-date');
                                if (date) {
                                    openTodayDayHistory(date);
                                }
                            });
                        }
                        initTodayDayHistoryModal();
                    }

                    function paintTodayCalMonth(host, monthDate, map, todayKey) {
                        const wrap = document.createElement('div');
                        wrap.className = 'today-cal__month';
                        const title = document.createElement('h3');
                        title.className = 'today-cal__month-title';
                        title.textContent = todayCalMonthNames[monthDate.getMonth()] + ' ' + monthDate.getFullYear();
                        wrap.appendChild(title);

                        const grid = document.createElement('div');
                        grid.className = 'today-cal__grid';
                        ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'].forEach(function(label) {
                            const dow = document.createElement('span');
                            dow.className = 'today-cal__dow';
                            dow.textContent = label;
                            grid.appendChild(dow);
                        });

                        const first = todayCalMonthStart(monthDate);
                        const pad = first.getDay() === 0 ? 6 : first.getDay() - 1;
                        for (let i = 0; i < pad; i++) {
                            const empty = document.createElement('span');
                            empty.className = 'today-cal__cell today-cal__cell--empty';
                            empty.setAttribute('aria-hidden', 'true');
                            grid.appendChild(empty);
                        }

                        const lastDate = new Date(monthDate.getFullYear(), monthDate.getMonth() + 1, 0).getDate();
                        for (let day = 1; day <= lastDate; day++) {
                            const cellDate = new Date(monthDate.getFullYear(), monthDate.getMonth(), day);
                            const key = formatDateKey(cellDate);
                            const isFuture = key > todayKey;
                            const cell = document.createElement(isFuture ? 'span' : 'button');
                            cell.className = 'today-cal__cell';
                            cell.textContent = String(day);
                            if (!isFuture) {
                                cell.type = 'button';
                                cell.classList.add('today-cal__cell--open');
                                cell.setAttribute('data-date', key);
                                cell.setAttribute('aria-label', 'История за ' + key);
                            }
                            if (key === todayKey) {
                                cell.classList.add('today-cal__cell--today');
                                cell.setAttribute('aria-current', 'date');
                            }
                            if (isFuture) {
                                cell.classList.add('today-cal__cell--future');
                            } else if (map[key] === 'success') {
                                cell.classList.add('today-cal__cell--success');
                            } else if (map[key] === 'fail') {
                                cell.classList.add('today-cal__cell--fail');
                            }
                            grid.appendChild(cell);
                        }

                        wrap.appendChild(grid);
                        host.appendChild(wrap);
                    }

                    function paintTodayCalendar() {
                        if (!timelineEl) {
                            return;
                        }
                        const lim = todayCalLimits();
                        if (!todayCalLeft) {
                            todayCalLeft = lim.maxLeft;
                        }
                        timelineEl.innerHTML = '';
                        const months = document.createElement('div');
                        months.className = 'today-cal__months';
                        paintTodayCalMonth(months, todayCalLeft, todayCalMap, lim.todayKey);
                        paintTodayCalMonth(months, todayCalAddMonths(todayCalLeft, 1), todayCalMap, lim.todayKey);
                        timelineEl.appendChild(months);
                        updateTodayCalNav();
                    }

                    function initTodayDayHistoryModal() {
                        const modal = document.getElementById('today_day_history');
                        if (!modal || modal.getAttribute('data-bound') === '1') {
                            return;
                        }
                        modal.setAttribute('data-bound', '1');
                        modal.querySelectorAll('[data-today-hist-close]').forEach(function(el) {
                            el.addEventListener('click', closeTodayDayHistory);
                        });
                        document.addEventListener('keydown', function(e) {
                            if (e.key === 'Escape' && !modal.hasAttribute('hidden')) {
                                closeTodayDayHistory();
                            }
                        });
                    }

                    function closeTodayDayHistory() {
                        const modal = document.getElementById('today_day_history');
                        if (!modal) {
                            return;
                        }
                        modal.setAttribute('hidden', '');
                        document.documentElement.classList.remove('today-day-hist-open');
                    }

                    function openTodayDayHistory(dateStr) {
                        const modal = document.getElementById('today_day_history');
                        const titleEl = document.getElementById('today-day-hist-title');
                        const kickerEl = document.getElementById('today-day-hist-kicker');
                        const statusEl = document.getElementById('today-day-hist-status');
                        const bodyEl = document.getElementById('today-day-hist-body');
                        if (!modal || !bodyEl) {
                            return;
                        }
                        modal.removeAttribute('hidden');
                        document.documentElement.classList.add('today-day-hist-open');
                        if (titleEl) {
                            titleEl.textContent = dateStr;
                        }
                        if (kickerEl) {
                            kickerEl.textContent = 'История дня';
                        }
                        if (statusEl) {
                            statusEl.className = 'today-day-hist__status';
                            statusEl.textContent = '';
                        }
                        bodyEl.innerHTML = '<p class="today-day-hist__loading">Загрузка…</p>';
                        $.ajax({
                            url: getAjaxUrl(),
                            type: 'POST',
                            data: {
                                action: 'daybooster_get_day_history',
                                date: dateStr
                            },
                            success: function(resp) {
                                let data = resp;
                                if (typeof resp === 'string') {
                                    try { data = JSON.parse(resp); } catch (e) {}
                                }
                                if (data && data.data && typeof data.data === 'object' && data.data.tasks) {
                                    data = Object.assign({}, data, data.data);
                                }
                                if (!data || !data.success) {
                                    bodyEl.innerHTML = '<p class="today-day-hist__empty">' + escapeHtml((data && data.message) || 'Не удалось загрузить день.') + '</p>';
                                    return;
                                }
                                renderTodayDayHistory(data);
                            },
                            error: function() {
                                bodyEl.innerHTML = '<p class="today-day-hist__empty">Не удалось загрузить день.</p>';
                            }
                        });
                    }

                    function renderTodayDayHistory(data) {
                        const titleEl = document.getElementById('today-day-hist-title');
                        const kickerEl = document.getElementById('today-day-hist-kicker');
                        const statusEl = document.getElementById('today-day-hist-status');
                        const bodyEl = document.getElementById('today-day-hist-body');
                        if (!bodyEl) {
                            return;
                        }
                        if (titleEl) {
                            titleEl.textContent = data.label || data.date || '';
                        }
                        if (kickerEl) {
                            kickerEl.textContent = data.weekday || 'История дня';
                        }
                        if (statusEl) {
                            statusEl.className = 'today-day-hist__status';
                            if (data.future) {
                                statusEl.textContent = data.message || 'Этот день ещё не наступил.';
                            } else if (data.saved && data.status === 'success') {
                                statusEl.classList.add('is-ok');
                                statusEl.textContent = data.pct != null ? ('Успешный день · ' + data.pct + '%') : 'Успешный день';
                            } else if (data.saved && data.status === 'fail') {
                                statusEl.classList.add('is-bad');
                                statusEl.textContent = data.pct != null ? ('Неуспешный день · ' + data.pct + '%') : 'Неуспешный день';
                            } else if (data.is_today) {
                                statusEl.textContent = 'День ещё не сохранён';
                            } else {
                                statusEl.textContent = 'Этот день не сохраняли';
                            }
                        }

                        if (data.future) {
                            bodyEl.innerHTML = '';
                            return;
                        }

                        const tasks = Array.isArray(data.tasks) ? data.tasks.slice() : [];
                        if (data.is_today && !data.saved) {
                            const dm = getDoneMap(data.date);
                            tasks.forEach(function(task) {
                                if (task && task.id && dm[task.id]) {
                                    task.done = true;
                                }
                            });
                        }
                        if (!tasks.length && data.is_today) {
                            document.querySelectorAll('#calendar_today .calendar_event').forEach(function(article) {
                                const wrap = article.querySelector('.event-todo-wrapper');
                                const titleEl = article.querySelector('.calendar_event_title');
                                const timeEl = article.querySelector('.calendar_event_time');
                                const check = article.querySelector('.calendar-done-checkbox');
                                tasks.push({
                                    id: wrap ? (wrap.getAttribute('data-event-id') || '') : '',
                                    title: titleEl ? String(titleEl.textContent || '').trim() : 'Дело',
                                    time: timeEl ? String(timeEl.textContent || '').trim() : '',
                                    done: !!(wrap && wrap.classList.contains('event-done')) || !!(check && check.checked)
                                });
                            });
                        }

                        let html = '';
                        const doneCount = typeof data.done === 'number' ? data.done : tasks.filter(function(t) { return t && t.done; }).length;
                        const totalCount = typeof data.total === 'number' ? data.total : tasks.length;
                        if (totalCount > 0) {
                            html += '<p class="today-day-hist__count">' + escapeHtml(String(doneCount)) + ' из ' + escapeHtml(String(totalCount)) + ' дел</p>';
                        }
                        if (!tasks.length) {
                            html += '<p class="today-day-hist__empty">На этот день дел не найдено.</p>';
                            bodyEl.innerHTML = html;
                            return;
                        }
                        html += '<ul class="today-day-hist__tasks">';
                        tasks.forEach(function(task) {
                            const done = !!(task && task.done);
                            const time = task && task.time ? String(task.time) : '';
                            const title = task && task.title ? String(task.title) : 'Дело';
                            html += '<li class="today-day-hist__task' + (done ? ' is-done' : '') + '">';
                            html += '<span class="today-day-hist__check" aria-hidden="true"></span>';
                            if (time) {
                                html += '<span class="today-day-hist__time">' + escapeHtml(time) + '</span>';
                            }
                            html += '<span class="today-day-hist__name">' + escapeHtml(title) + '</span>';
                            html += '<span class="today-day-hist__flag">' + (done ? 'Сделано' : 'Не сделано') + '</span>';
                            html += '</li>';
                        });
                        html += '</ul>';
                        bodyEl.innerHTML = html;
                    }

                    function applyDayProgressAggregates(aggregates) {
                        if (!aggregates || typeof aggregates !== 'object') {
                            return;
                        }
                        const streakValEl = document.getElementById('streak_value');
                        const streakHintEl = document.getElementById('streak_hint');
                        const streakN = typeof aggregates.streak === 'number' ? aggregates.streak : 0;
                        if (streakValEl) {
                            streakValEl.textContent = String(streakN);
                        }
                        if (streakHintEl) {
                            if (streakN === 0) {
                                streakHintEl.textContent = 'Подряд идущие успешные сохранённые дни; пустой сегодняшний день серию не сбрасывает.';
                            } else if (streakN === 1) {
                                streakHintEl.textContent = 'Один успешный день подряд.';
                            } else {
                                streakHintEl.textContent = 'Уже ' + streakN + ' успешных дней подряд.';
                            }
                        }
                        const w = aggregates.week;
                        const weekAvgEl = document.getElementById('week_summary_avg');
                        if (w && weekSummaryValueEl) {
                            weekSummaryValueEl.textContent = (typeof w.success === 'number' ? w.success : 0) + '/7';
                        }
                        if (w && weekSummaryHintEl) {
                            const successCount = typeof w.success === 'number' ? w.success : 0;
                            if (successCount === 0) {
                                weekSummaryHintEl.textContent = 'На этой неделе пока нет успешных дней.';
                            } else if (successCount === 7) {
                                weekSummaryHintEl.textContent = 'Вы закрыли все дни этой недели. Отличный результат!';
                            } else {
                                weekSummaryHintEl.textContent = 'Вы уже закрыли ' + successCount + ' из 7 дней этой недели.';
                            }
                        }
                        if (w && weekAvgEl) {
                            const rec = typeof w.recorded === 'number' ? w.recorded : 0;
                            if (rec > 0 && typeof w.avg_pct === 'number') {
                                weekAvgEl.textContent = 'Средний процент по сохранённым дням недели: ' + w.avg_pct + '% (' + rec + ' из 7 с записью).';
                                weekAvgEl.hidden = false;
                            } else {
                                weekAvgEl.textContent = '';
                                weekAvgEl.hidden = true;
                            }
                        }
                    }

                    function loadDaysTimeline(forcedFetchId) {
                        if (!timelineEl) return;
                        const fetchId = typeof forcedFetchId === 'number' ? forcedFetchId : ++todayProgressFetchId;
                        bindTodayCalNav();
                        const range = todayCalRange();
                        $.ajax({
                            url: getAjaxUrl(),
                            type: 'POST',
                            data: {
                                action: 'daybooster_get_day_statuses',
                                start: range.start,
                                end: range.end
                            },
                            success: function(resp) {
                                let data = resp;
                                if (typeof resp === 'string') {
                                    try { data = JSON.parse(resp); } catch (e) {}
                                }
                                const map = (data && data.days) ? data.days : {};
                                todayCalMap = map;
                                if (data && data.aggregates) {
                                    applyDayProgressAggregates(data.aggregates);
                                }
                                applyTodaySavedFromServer(map, data && data.aggregates, fetchId);
                                if (hydrateTodayDoneFromServer(map, data && data.done_maps) === 'mismatch') {
                                    unlockTodayUI();
                                }
                                paintTodayCalendar();
                            }
                        });
                    }

                    function pruneLocalDoneMaps(keptDates) {
                        const todayKey = formatDateKey(new Date());
                        const kept = {};
                        (Array.isArray(keptDates) ? keptDates : []).forEach(function(d) {
                            if (d) {
                                kept[String(d)] = true;
                            }
                        });
                        kept[todayKey] = true;
                        try {
                            const remove = [];
                            for (let i = 0; i < localStorage.length; i++) {
                                const k = localStorage.key(i);
                                if (!k || k.indexOf(STORAGE_PREFIX) !== 0) {
                                    continue;
                                }
                                const date = k.slice(STORAGE_PREFIX.length);
                                if (!kept[date]) {
                                    remove.push(k);
                                }
                            }
                            remove.forEach(function(k) {
                                localStorage.removeItem(k);
                            });
                        } catch (e) {}
                    }

                    function bindTodayCalClear() {
                        const btn = document.getElementById('today_cal_clear_history');
                        if (!btn || btn.getAttribute('data-bound') === '1') {
                            return;
                        }
                        btn.setAttribute('data-bound', '1');
                        btn.addEventListener('click', function() {
                            if (btn.disabled) {
                                return;
                            }
                            const ok = window.confirm('Очистить историю завершённых программ и прошлых дней? Дни текущих программ останутся.');
                            if (!ok) {
                                return;
                            }
                            const nonce = (typeof window.daybooster_vars !== 'undefined' && window.daybooster_vars.clearCalendarHistoryNonce)
                                ? String(window.daybooster_vars.clearCalendarHistoryNonce)
                                : '';
                            if (!nonce) {
                                showAlert('Обновите страницу и попробуйте снова.', 'error');
                                return;
                            }
                            btn.disabled = true;
                            $.ajax({
                                url: getAjaxUrl(),
                                type: 'POST',
                                data: {
                                    action: 'daybooster_clear_calendar_history',
                                    nonce: nonce
                                },
                                success: function(resp) {
                                    let data = resp;
                                    if (typeof resp === 'string') {
                                        try { data = JSON.parse(resp); } catch (e) {}
                                    }
                                    btn.disabled = false;
                                    if (!data || !data.success) {
                                        showAlert((data && data.message) ? data.message : 'Не удалось очистить историю.', 'error');
                                        return;
                                    }
                                    pruneLocalDoneMaps(data.kept_dates);
                                    if (data.aggregates) {
                                        applyDayProgressAggregates(data.aggregates);
                                    }
                                    const reloadId = ++todayProgressFetchId;
                                    loadDaysTimeline(reloadId);
                                    if (typeof loadWeekSummary === 'function') {
                                        loadWeekSummary(reloadId);
                                    }
                                    showAlert(data.message || 'История очищена.', 'success');
                                },
                                error: function() {
                                    btn.disabled = false;
                                    showAlert('Не удалось очистить историю.', 'error');
                                }
                            });
                        });
                    }

                    bindTodayCalClear();
                    if (timelineEl || (weekSummaryEl && weekSummaryValueEl)) {
                        const bootFetchId = ++todayProgressFetchId;
                        if (timelineEl) {
                            loadDaysTimeline(bootFetchId);
                        }
                        if (weekSummaryEl && weekSummaryValueEl) {
                            loadWeekSummary(bootFetchId);
                        }
                    }

                    function getCurrentWeekRange() {
                        const today = new Date();
                        const day = today.getDay(); // 0 (Sun) - 6 (Sat)
                        const diffToMonday = (day === 0 ? -6 : 1 - day);
                        const monday = new Date(today);
                        monday.setDate(today.getDate() + diffToMonday);
                        const sunday = new Date(monday);
                        sunday.setDate(monday.getDate() + 6);
                        return {
                            start: formatDateKey(monday),
                            end: formatDateKey(sunday)
                        };
                    }

                    function loadWeekSummary(forcedFetchId) {
                        if (!weekSummaryEl || !weekSummaryValueEl) return;
                        const fetchId = typeof forcedFetchId === 'number' ? forcedFetchId : ++todayProgressFetchId;
                        const range = getCurrentWeekRange();
                        $.ajax({
                            url: getAjaxUrl(),
                            type: 'POST',
                            data: {
                                action: 'daybooster_get_day_statuses',
                                start: range.start,
                                end: range.end
                            },
                            success: function(resp) {
                                let data = resp;
                                if (typeof resp === 'string') {
                                    try { data = JSON.parse(resp); } catch (e) {}
                                }
                                const map = (data && data.days) ? data.days : {};
                                if (data && data.aggregates) {
                                    applyDayProgressAggregates(data.aggregates);
                                } else {
                                    const days = [];
                                    const startDate = new Date(range.start + 'T00:00:00');
                                    for (let i = 0; i < 7; i++) {
                                        const d = new Date(startDate);
                                        d.setDate(startDate.getDate() + i);
                                        days.push(formatDateKey(d));
                                    }
                                    let successCount = 0;
                                    days.forEach(function(dateStr) {
                                        if (map[dateStr] === 'success') {
                                            successCount++;
                                        }
                                    });
                                    weekSummaryValueEl.textContent = successCount + '/7';
                                    if (weekSummaryHintEl) {
                                        if (successCount === 0) {
                                            weekSummaryHintEl.textContent = 'На этой неделе пока нет успешных дней.';
                                        } else if (successCount === 7) {
                                            weekSummaryHintEl.textContent = 'Вы закрыли все дни этой недели. Отличный результат!';
                                        } else {
                                            weekSummaryHintEl.textContent = 'Вы уже закрыли ' + successCount + ' из 7 дней этой недели.';
                                        }
                                    }
                                }
                                applyTodaySavedFromServer(map, data && data.aggregates, fetchId);
                                if (hydrateTodayDoneFromServer(map, data && data.done_maps) === 'mismatch') {
                                    unlockTodayUI();
                                }
                            }
                        });
                    }

                    if (saveBtn) {
                        saveBtn.addEventListener('click', function() {
                            if (todayDayLocked) {
                                return;
                            }
                            const wrappers = calendarDayEl.querySelectorAll('.event-todo-wrapper');
                            const total = wrappers.length;
                            const done = Array.prototype.filter.call(wrappers, function(w) {
                                return w.classList.contains('event-done');
                            }).length;
                            const success = total > 0 && done === total;
                            const dateStr = formatDateKey(new Date());

                            function performSaveDay() {
                                if (saveStatus) {
                                    saveStatus.textContent = 'Сохранение...';
                                    saveStatus.classList.remove('day-save__status--success', 'day-save__status--fail', 'day-save__status--error');
                                }

                                $.ajax({
                                    url: getAjaxUrl(),
                                    type: 'POST',
                                    data: {
                                        action: 'daybooster_save_day_status',
                                        date: dateStr,
                                        status: success ? 'success' : 'fail',
                                        done: done,
                                        total: total,
                                        done_map: JSON.stringify(getDoneMap(dateStr))
                                    },
                                    success: function(resp) {
                                        let data = resp;
                                        if (typeof resp === 'string') {
                                            try { data = JSON.parse(resp); } catch (e) {}
                                        }
                                        if (!data || !data.success) {
                                            if (saveStatus) {
                                                saveStatus.textContent = (data && data.message) ? data.message : 'Ошибка при сохранении дня.';
                                                saveStatus.classList.add('day-save__status--error');
                                            }
                                            const msg = data && data.message ? String(data.message) : '';
                                            if (msg.indexOf('уже сохранён') !== -1) {
                                                lockTodayUI();
                                            }
                                            return;
                                        }
                                        lockTodayUI();
                                        if (saveStatus) {
                                            const msg = data.message || (success ? 'День сохранён как успешный.' : 'День сохранён как неуспешный.');
                                            saveStatus.textContent = msg;
                                            saveStatus.classList.add(success ? 'day-save__status--success' : 'day-save__status--fail');
                                        }
                                        if (data.aggregates) {
                                            applyDayProgressAggregates(data.aggregates);
                                        }
                                        const reloadId = ++todayProgressFetchId;
                                        loadDaysTimeline(reloadId);
                                        loadWeekSummary(reloadId);
                                        if (data.programs_just_completed && data.programs_just_completed.length) {
                                            showProgramCompletedCongrats(data.programs_just_completed);
                                        }
                                        if (data.show_premium_offer && data.premium_url) {
                                            showFirstDayPremiumOffer(String(data.premium_url));
                                        }
                                        const progressTab = document.getElementById('today-tab-btn-progress');
                                        if (progressTab && typeof progressTab.click === 'function') {
                                            window.setTimeout(function() {
                                                progressTab.click();
                                            }, 400);
                                        }
                                    },
                                    error: function() {
                                        if (saveStatus) {
                                            saveStatus.textContent = 'Ошибка при сохранении дня.';
                                            saveStatus.classList.add('day-save__status--error');
                                        }
                                    }
                                });
                            }

                            showDaySaveConfirm(success, performSaveDay);
                        });
                    }

                    const pdfBtn = document.getElementById('day_pdf_btn');
                    if (pdfBtn) {
                        pdfBtn.addEventListener('click', function() {
                            if (!todaySavedOnServer) {
                                return;
                            }
                            const nonce = (typeof window.daybooster_vars !== 'undefined' && window.daybooster_vars.todayPdfNonce)
                                ? String(window.daybooster_vars.todayPdfNonce)
                                : '';
                            if (!nonce) {
                                showAlert('Не удалось подготовить загрузку PDF. Обновите страницу.', 'error');
                                return;
                            }
                            const dateStr = formatDateKey(new Date());
                            const doneMap = getDoneMap(dateStr);
                            const fd = new FormData();
                            fd.append('action', 'daybooster_export_today_pdf');
                            fd.append('nonce', nonce);
                            fd.append('date', dateStr);
                            fd.append('done_map', JSON.stringify(doneMap));
                            pdfBtn.disabled = true;
                            fetch(getAjaxUrl(), {
                                method: 'POST',
                                body: fd,
                                credentials: 'same-origin'
                            }).then(function(r) {
                                const ct = (r.headers.get('content-type') || '').toLowerCase();
                                if (ct.indexOf('application/pdf') !== -1) {
                                    return r.blob().then(function(blob) {
                                        const url = URL.createObjectURL(blob);
                                        const a = document.createElement('a');
                                        a.href = url;
                                        var pdfSlug = (typeof window.daybooster_vars !== 'undefined' && window.daybooster_vars.todayPdfUserSlug)
                                            ? String(window.daybooster_vars.todayPdfUserSlug)
                                            : 'user';
                                        a.download = pdfSlug + '-' + dateStr + '-Daybooster.pdf';
                                        document.body.appendChild(a);
                                        a.click();
                                        a.remove();
                                        URL.revokeObjectURL(url);
                                    });
                                }
                                return r.text().then(function(text) {
                                    let data = null;
                                    try {
                                        data = text ? JSON.parse(text) : null;
                                    } catch (e) {
                                        data = null;
                                    }
                                    const msg = (data && data.message) ? String(data.message)
                                        : (data && data.data && data.data.message) ? String(data.data.message)
                                            : 'Не удалось сформировать PDF.';
                                    showAlert(msg, 'error');
                                });
                            }).catch(function() {
                                showAlert('Ошибка сети при скачивании PDF.', 'error');
                            }).finally(function() {
                                pdfBtn.disabled = false;
                            });
                        });
                    }

                    $(calendarDayEl).on('change', '.calendar-done-checkbox', function(e) {
                        e.stopPropagation();
                        if (todayDayLocked) {
                            const $w = $(this).closest('.event-todo-wrapper');
                            this.checked = $w.hasClass('event-done');
                            return;
                        }
                        const eventId = this.getAttribute('data-event-id');
                        if (!eventId) return;
                        const $wrapper = $(this).closest('.event-todo-wrapper');
                        const dateStr = $wrapper.attr('data-date');
                        if (!dateStr) return;
                        const map = getDoneMap(dateStr);
                        map[eventId] = this.checked;
                        setDoneMap(dateStr, map);
                        $wrapper.toggleClass('event-done', map[eventId]);
                        updateDayProgressFromDom();
                    });
                }
                if (calendarTomorrowEl) {
                    const tomorrow = new Date();
                    tomorrow.setDate(tomorrow.getDate() + 1);
                    const day = String(tomorrow.getDate()).padStart(2, '0');
                    const month = String(tomorrow.getMonth() + 1).padStart(2, '0');
                    const year = tomorrow.getFullYear();
                    const initialDate = year + '-' + month + '-' + day;
                    const calendarTomorrowInstance = new FullCalendar.Calendar(calendarTomorrowEl, {
                        plugins: [listPlugin],
                        initialView: 'listDay',
                        locales: ruLocale,
                        locale: 'ru',
                        initialDate: initialDate,
                        events: eventsForRender,
                        headerToolbar:{
                            end:""
                        }
                    });
                    calendarTomorrowInstance.render();
                }
                if (calendarWeekEl) {
                    const calendarWeekInstance = new FullCalendar.Calendar(calendarWeekEl, {
                        plugins: [listPlugin],
                        initialView: 'listWeek',
                        locales: ruLocale,
                        locale: 'ru',
                        events: eventsForRender
                    });
                    calendarWeekInstance.render();
                }
                if (calendarMonthEl) {
                    const calendarMonthInstance = new FullCalendar.Calendar(calendarMonthEl, {
                        plugins: [listPlugin],
                        initialView: 'listMonth',
                        locales: ruLocale,
                        locale: 'ru',
                        events: eventsForRender
                    });
                    calendarMonthInstance.render();
                }
            })
            .catch(function() {
                if (DEBUG) console.error('Ошибка загрузки событий календаря');

                // Фоллбек: календарь должен отрисоваться даже без данных событий.
                // Это помогает не "ронять" весь UI, если AJAX вернул ошибку.
                try {
                    if (calendarDayEl && calendarDayEl.getAttribute('data-daybooster-accordion') !== '1') {
                        const calendarDayInstance = new FullCalendar.Calendar(calendarDayEl, {
                            plugins: [listPlugin],
                            initialView: 'listDay',
                            locales: ruLocale,
                            locale: 'ru',
                            editable: true,
                            events: [],
                            headerToolbar: { end: "" }
                        });
                        calendarDayInstance.render();
                    }
                    if (calendarTomorrowEl) {
                        const calendarTomorrowInstance = new FullCalendar.Calendar(calendarTomorrowEl, {
                            plugins: [listPlugin],
                            initialView: 'listDay',
                            locales: ruLocale,
                            locale: 'ru',
                            events: [],
                            headerToolbar: { end: "" }
                        });
                        calendarTomorrowInstance.render();
                    }
                    if (calendarWeekEl) {
                        const calendarWeekInstance = new FullCalendar.Calendar(calendarWeekEl, {
                            plugins: [listPlugin],
                            initialView: 'listWeek',
                            locales: ruLocale,
                            locale: 'ru',
                            events: []
                        });
                        calendarWeekInstance.render();
                    }
                    if (calendarMonthEl) {
                        const calendarMonthInstance = new FullCalendar.Calendar(calendarMonthEl, {
                            plugins: [listPlugin],
                            initialView: 'listMonth',
                            locales: ruLocale,
                            locale: 'ru',
                            events: []
                        });
                        calendarMonthInstance.render();
                    }
                } catch (e) {
                    if (DEBUG) console.error('Fallback render calendar failed', e);
                }
            });
    }

    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });




    $('.send_data').on('click', function(e) {
        e.preventDefault();
        const $button = $(this);
        const way = $button.data('way');
        const day = $button.data('day');

        if (!way || !day) {
            showAlert('Недостаточно данных для отправки. Пожалуйста, повторите попытку.', 'error');
            return;
        }

        $button.prop('disabled', true).addClass('loading');

        $.ajax({
            url: getAjaxUrl(),
            data: { action: 'sendlist', way: way, day: day },
            type: 'POST',
            dataType: 'json',
            success: function(response) {
                if (response && response.success) {
                    showAlert('Данные успешно отправлены!', 'success');
                } else {
                    const errorMessage = (response && response.data && response.data.message) ? response.data.message : 'Произошла ошибка при обработке запроса';
                    showAlert(errorMessage, 'error');
                }
            },
            error: function() {
                showAlert('Произошла сетевая ошибка. Проверьте подключение и попробуйте снова.', 'error');
            },
            complete: function() {
                $button.prop('disabled', false).removeClass('loading');
            }
        });
    });
    var $toTop = $('[data-db-to-top]');
    if ($toTop.length) {
        var toTopVisible = false;
        var toggleToTop = function() {
            var show = $(window).scrollTop() > 360;
            if (show === toTopVisible) {
                return;
            }
            toTopVisible = show;
            $toTop.toggleClass('is-visible', show);
        };
        toggleToTop();
        $(window).on('scroll', toggleToTop);
        $toTop.on('click', function() {
            var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
        });
    }

    $(".menu_toggle").on('click',function(e){
        e.preventDefault();
        var $btn = $(this);
        var $menu = $(".header_menu_mobile");
        var willOpen = !$btn.hasClass('is-open');
        $btn.toggleClass('is-open', willOpen);
        $btn.attr('aria-expanded', willOpen ? 'true' : 'false');
        document.documentElement.classList.toggle('header-menu-open', willOpen);
        $menu.stop(true, true).slideToggle(200, function() {
            if (!willOpen) {
                document.documentElement.classList.remove('header-menu-open');
            }
        });
    })
    $(".sidebar_mobile_toggle").on('click',function(e){
        e.preventDefault();
        $(this).toggleClass('is-open');
        $(".sidebar_block_mobile").stop(true, true).slideToggle(180);
    })
    $(window).on('resize', function() {
        if (window.matchMedia('(min-width: 1025px)').matches) {
            $('.menu_toggle').removeClass('is-open').attr('aria-expanded', 'false');
            $('.header_menu_mobile').hide();
            document.documentElement.classList.remove('header-menu-open');
        }
    });
    $(".header_meta_toggle").on('click',function(e){
        e.preventDefault();
        var $btn = $(this);
        $(".header_meta_block").slideToggle(160, function() {
            $btn.attr('aria-expanded', $(this).is(':visible') ? 'true' : 'false');
        });
    })
    $(document).mouseup(function (e) {
        let container = $(".header_meta_block");
        let toggle = $(".header_meta_toggle");
        if (container.has(e.target).length === 0 && toggle.has(e.target).length === 0){
            container.hide();
        }
    });
    // Клик по ссылкам в выпадающем меню (Выход, Настройки) — не перехватывать, дать переходу выполниться
    $(document).on('click', '.header_meta_block a[href]', function(e) {
        if (this.getAttribute('href') !== '#' && this.href) {
            e.stopPropagation();
        }
    });

    const filter = $(".filter");


    $(".filter_box_row").on('click',function(){
        $(this).toggleClass('active');
        $(this).attr('aria-checked', $(this).hasClass('active') ? 'true' : 'false');
    })

    /** Загрузка программ. Ответ сервера вставляется как HTML — бэкенд должен отдавать безопасный разметку. */
    const PROGRAMS_PER_PAGE = 12;
    let programsPage = 1;
    let programsSearch = "";
    let programsRandSeed = (typeof window.dayboosterMainRandSeed !== "undefined" && window.dayboosterMainRandSeed)
        ? parseInt(window.dayboosterMainRandSeed, 10)
        : null;
    const isMainProgramsPage = $(".front_page").length > 0;

    function ensureProgramsLoadMoreButton() {
        if (!isMainProgramsPage) return;
        if (!$("#programs_load_more_btn").length) {
            $(".response_wrap").append(
                '<div class="programs_load_more_wrap">' +
                '<button type="button" id="programs_load_more_btn" class="daybooster_btn programs_load_more_btn">Показать ещё</button>' +
                '</div>'
            );
        }
    }

    function setProgramsLoadMoreLoading(isLoading) {
        const $btn = $("#programs_load_more_btn");
        if (!$btn.length) return;
        $btn.prop("disabled", !!isLoading);
        $btn.toggleClass("loading", !!isLoading);
        $btn.text(isLoading ? "Загрузка..." : "Показать ещё");
    }

    function hideProgramsLoadMoreButton() {
        if (!isMainProgramsPage) return;
        $("#programs_load_more_wrap, #programs_load_more_btn").remove();
    }

    function getProgramsFilterPayload() {
        const dirIds = (filter.find('.direction .active').map((_, el) => $(el).attr('data-id')).get()).toString();
        const accessIds = (filter.find('.access .active').map((_, el) => $(el).attr('data-id')).get()).toString();
        const specialIds = (filter.find('.special .active').map((_, el) => $(el).attr('data-id')).get()).toString();
        return { dirs: dirIds, access: accessIds, special: specialIds };
    }

    function loadPrograms(search = "", reset = false) {
        if (reset) {
            programsPage = 1;
            programsSearch = search || "";
            if (isMainProgramsPage) {
                // Пересоздаём seed только при новом поиске/фильтре.
                programsRandSeed = Math.floor(Math.random() * 2147483646) + 1;
                window.dayboosterMainRandSeed = programsRandSeed;
            }
        }
        if (typeof search !== "string") search = "";
        const hasSearch = (programsSearch || "").toString().trim() !== "";
        const hasFilter = filter.find('.direction .active').length > 0
            || filter.find('.access .active').length > 0
            || filter.find('.special .active').length > 0;

        const dirIds = (filter.find('.direction .active').map((_, el) => $(el).attr('data-id')).get()).toString();
        const accessIds = (filter.find('.access .active').map((_, el) => $(el).attr('data-id')).get()).toString();
        const specialIds = (filter.find('.special .active').map((_, el) => $(el).attr('data-id')).get()).toString();
        const data = {
            action: 'load_programs',
            count: PROGRAMS_PER_PAGE,
            page: programsPage
        };
        if (isMainProgramsPage) {
            // На главной делаем случайную выдачу.
            data.rand_order = 1;
            if (programsRandSeed) data.rand_seed = programsRandSeed;
        }
        if (dirIds.length > 0) data.dirs = dirIds;
        if (accessIds.length > 0) data.access = accessIds;
        if (specialIds.length > 0) data.special = specialIds;
        if (search !== "") data.s = search;

        $.ajax({
            url: getAjaxUrl(),
            data: data,
            type: 'POST',
            beforeSend: function() {
                blockEl('.response_wrap');
            },
            success: function(response) {
                if (isMainProgramsPage) {
                    // На главной пагинацию не показываем — вместо неё Load More.
                    const $resp = $(response);
					// Если пагинация была в ответе сервера — значит есть следующая страница.
					const hasPagination = $resp.find(".pagination, nav.navigation.pagination, .navigation.pagination, .nav-links").length > 0;
					// Убираем любые варианты пагинации на главной.
					$resp.find(".pagination, nav.navigation.pagination, .navigation.pagination, .nav-links").remove();
                    $(".response_wrap").html($resp);
					$(".response_wrap").find(".pagination, nav.navigation.pagination, .navigation.pagination, .nav-links").remove();

                    if ((hasSearch || hasFilter) && hasPagination) {
                        ensureProgramsLoadMoreButton();
                    } else {
                        hideProgramsLoadMoreButton();
                    }
                } else {
                    $(".response_wrap").html(response);
                    hideProgramsLoadMoreButton();
                }
            },
            error: function() {
                showAlert('Произошла сетевая ошибка. Проверьте подключение и попробуйте снова.', 'error');
            },
            complete: function() {
                unblockEl('.response_wrap');
                const $clear = $("#clear_filter");
                if ($clear.length) {
                    $clear.toggleClass("hero_search__clear--visible", search !== "");
                }
            }
        });
    }

    $(".load_programs").on('click',function (e) {
        e.preventDefault();
        loadPrograms("", true);
    })

    const $searchCapability = $("#search_capability");
    if ($searchCapability.length) {
        $searchCapability.on('submit', function (e) {
            e.preventDefault();
            let value = $('#capability-input').val().trim();
            if (value === "") {
                showAlert('Пожалуйста, введите текст для поиска', 'info');
            } else {
                loadPrograms(value, true);
            }
        });
    }

    const $clearFilter = $("#clear_filter");
    if ($clearFilter.length) {
        $clearFilter.on('click', function (e) {
            e.preventDefault();
            $("#capability-input").val("");
            $clearFilter.removeClass("hero_search__clear--visible");
            loadPrograms("", true);
        });
    }

    // Load More (подгружает только карточки без обёртки)
    $(document).on('click', '#programs_load_more_btn', function(e) {
        e.preventDefault();
        if ($(this).prop('disabled')) return;

        setProgramsLoadMoreLoading(true);
        programsPage++;

        const dirIds = (filter.find('.direction .active').map((_, el) => $(el).attr('data-id')).get()).toString();
        const accessIds = (filter.find('.access .active').map((_, el) => $(el).attr('data-id')).get()).toString();
        const specialIds = (filter.find('.special .active').map((_, el) => $(el).attr('data-id')).get()).toString();

        const data = {
            action: 'load_programs_cards',
            count: PROGRAMS_PER_PAGE,
            page: programsPage,
            s: programsSearch || ""
        };
        if (isMainProgramsPage) {
            // На главной делаем случайную выдачу.
            data.rand_order = 1;
            if (programsRandSeed) data.rand_seed = programsRandSeed;
        }
        if (dirIds.length > 0) data.dirs = dirIds;
        if (accessIds.length > 0) data.access = accessIds;
        if (specialIds.length > 0) data.special = specialIds;

        $.ajax({
            url: getAjaxUrl(),
            data: data,
            type: 'POST',
            beforeSend: function() {
                blockEl('.response_wrap');
            },
            success: function(response) {
                const html = (response || '').toString();
                if (!html.trim()) {
                    hideProgramsLoadMoreButton();
                    return;
                }
                const $grid = $(".response_wrap .capability_cards_grid.page");
                if ($grid.length) {
                    $grid.append(html);
                } else {
                    // fallback: если разметка неожиданная — просто заменим контент
                    $(".response_wrap").append(html);
                }
            },
            error: function() {
                showAlert('Произошла сетевая ошибка. Проверьте подключение и попробуйте снова.', 'error');
                programsPage = Math.max(1, programsPage - 1); // откат страницы
            },
            complete: function() {
                unblockEl('.response_wrap');
                setProgramsLoadMoreLoading(false);
            }
        });
    });

    // Нумерация страниц (только НЕ главная): клики по пагинации перезагружают список через AJAX.
    if (!isMainProgramsPage) {
        $(document).on('click', '.response_wrap .pagination a.page-numbers', function(e) {
            e.preventDefault();
            const href = $(this).attr('href') || '';
            let page = null;
            const m1 = href.match(/[?&]paged=(\d+)/);
            const m2 = href.match(/\/page\/(\d+)/);
            if (m1 && m1[1]) page = parseInt(m1[1], 10);
            else if (m2 && m2[1]) page = parseInt(m2[1], 10);
            // Если ссылка "1" ведёт на базовый URL без paged=1, то в href цифры нет.
            // Тогда берём номер из текста кнопки.
            if (!page) {
                const txt = ($(this).text() || '').trim();
                const txtNum = parseInt(txt, 10);
                if (!isNaN(txtNum) && txtNum >= 1) {
                    page = txtNum;
                }
            }
            if (!page || page < 1) return;

            programsPage = page;
            loadPrograms(programsSearch || "", false);
        });
    }

    $(document).on('click', '[data-faq-toggle]', function() {
        const $btn = $(this);
        const expanded = $btn.attr('aria-expanded') === 'true';
        const $answer = $('#' + $btn.attr('aria-controls'));
        $btn.attr('aria-expanded', !expanded);
        $answer.slideToggle(200, function() {
            $answer.prop('hidden', $btn.attr('aria-expanded') !== 'true');
        });
    });

    (function initDbFeedbackModal() {
        const modal = document.getElementById('db-feedback-modal');
        if (!modal) return;
        const dialog = modal.querySelector('.db-feedback-modal__dialog');
        const openers = document.querySelectorAll('[data-db-feedback-open]');
        const closers = modal.querySelectorAll('[data-db-feedback-close]');
        let lastFocus = null;
        let previousOverflow = '';

        function openModal() {
            lastFocus = document.activeElement;
            modal.removeAttribute('hidden');
            modal.setAttribute('aria-hidden', 'false');
            document.documentElement.classList.add('db-feedback-modal-open');
            previousOverflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
            const $mobileMenu = $('.header_menu_mobile');
            if ($mobileMenu.length && $mobileMenu.is(':visible')) {
                $mobileMenu.slideUp(180);
                $('.menu_toggle').removeClass('is-open').attr('aria-expanded', 'false');
                document.documentElement.classList.remove('header-menu-open');
            }
            window.setTimeout(function() {
                if (!dialog) return;
                const first = dialog.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
                if (first) first.focus();
            }, 10);
        }

        function closeModal() {
            modal.setAttribute('hidden', '');
            modal.setAttribute('aria-hidden', 'true');
            document.documentElement.classList.remove('db-feedback-modal-open');
            document.body.style.overflow = previousOverflow;
            if (lastFocus && typeof lastFocus.focus === 'function') {
                try {
                    lastFocus.focus();
                } catch (e) { /* ignore */ }
            }
        }

        openers.forEach(function(el) {
            el.addEventListener('click', function(e) {
                e.preventDefault();
                openModal();
            });
        });
        closers.forEach(function(el) {
            el.addEventListener('click', function() {
                closeModal();
            });
        });
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && !modal.hasAttribute('hidden')) {
                closeModal();
            }
        });

        if (dialog) {
            dialog.addEventListener('keydown', function(e) {
                if (e.key !== 'Tab' || modal.hasAttribute('hidden')) return;
                const focusables = dialog.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])');
                const list = Array.prototype.filter.call(focusables, function(fel) {
                    return fel.offsetParent !== null || fel.getClientRects().length > 0;
                });
                if (list.length === 0) return;
                const first = list[0];
                const last = list[list.length - 1];
                if (e.shiftKey && document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                } else if (!e.shiftKey && document.activeElement === last) {
                    e.preventDefault();
                    first.focus();
                }
            });
        }

        const toast = document.getElementById('db-feedback-toast');
        let toastHideTimer = null;

        function hideFeedbackToast() {
            if (!toast) return;
            toast.classList.remove('is-visible');
            window.clearTimeout(toastHideTimer);
            toastHideTimer = window.setTimeout(function() {
                toast.setAttribute('hidden', '');
                toastHideTimer = null;
            }, 420);
        }

        function showFeedbackSuccessToast() {
            if (!toast) return;
            window.clearTimeout(toastHideTimer);
            toast.removeAttribute('hidden');
            window.requestAnimationFrame(function() {
                toast.classList.add('is-visible');
            });
            toastHideTimer = window.setTimeout(hideFeedbackToast, 5600);
        }

        if (toast) {
            const toastClose = toast.querySelector('.db-feedback-toast__close');
            if (toastClose) {
                toastClose.addEventListener('click', function() {
                    window.clearTimeout(toastHideTimer);
                    hideFeedbackToast();
                });
            }
        }

        document.addEventListener('wpcf7mailsent', function(ev) {
            if (!ev.target || !modal.contains(ev.target)) return;
            try {
                showFeedbackSuccessToast();
                window.setTimeout(closeModal, 520);
            } catch (err) {
                /* не мешаем CF7 завершить UI, если тост упал */
            }
        });
    })();

    /** Приветственный чеклист в кабинете (только серверные шаги; localStorage — скрытие блока). */
    (function initCabinetWelcome() {
        const root = document.getElementById('daybooster_cabinet_welcome');
        if (!root) return;

        const LS_KEY = 'daybooster_cabinet_welcome_v2';

        function readState(userId) {
            try {
                const raw = localStorage.getItem(LS_KEY);
                if (!raw) return { hidden: false };
                const o = JSON.parse(raw);
                if (String(o.userId) !== String(userId)) return { hidden: false };
                return { hidden: !!o.hidden };
            } catch (e) {
                return { hidden: false };
            }
        }

        function writeState(userId, next) {
            try {
                localStorage.setItem(LS_KEY, JSON.stringify(Object.assign({ userId: Number(userId) }, next)));
            } catch (e) { /* ignore */ }
        }

        const userId = root.getAttribute('data-user-id') || '0';
        const serverProgram = root.getAttribute('data-server-program') === '1';
        const serverDigest = root.getAttribute('data-server-digest') === '1';

        let state = readState(userId);
        if (state.hidden) {
            root.classList.add('cabinet_welcome--hidden');
            return;
        }

        const doneMsg = document.getElementById('daybooster_cabinet_welcome_done');
        const dismissBtn = document.getElementById('daybooster_cabinet_welcome_dismiss');

        root.querySelectorAll('.cabinet_welcome_step').forEach(function (li) {
            const key = li.getAttribute('data-step');
            const done = key === 'program' ? serverProgram : key === 'digest' ? serverDigest : false;
            li.classList.toggle('cabinet_welcome_step--done', done);
        });
        if (doneMsg) {
            const all = serverProgram && serverDigest;
            doneMsg.hidden = !all;
            root.classList.toggle('cabinet_welcome--all-done', all);
        }

        if (dismissBtn) {
            dismissBtn.addEventListener('click', function () {
                writeState(userId, { hidden: true });
                root.classList.add('cabinet_welcome--hidden');
            });
        }
    })();

    $(document).on('click', '#daybooster_cabinet_stats .cabinet_stats__completed-programs-remove', function (e) {
        e.preventDefault();
        const $btn = $(this);
        const key = $btn.attr('data-completed-program-key');
        if (!key) {
            return;
        }
        const $section = $btn.closest('.cabinet_stats__completed-programs');
        const confirmMsg = ($section.length && $section.data('confirmRemoveCompleted'))
            ? String($section.data('confirmRemoveCompleted'))
            : 'Удалить эту программу из истории пройденных?';
        if (!window.confirm(confirmMsg)) {
            return;
        }
        const nonce = (typeof window.daybooster_vars !== 'undefined' && window.daybooster_vars.removeCompletedProgramNonce)
            ? String(window.daybooster_vars.removeCompletedProgramNonce) : '';
        if (!nonce) {
            showAlert('Обновите страницу и попробуйте снова.', 'error');
            return;
        }
        $btn.prop('disabled', true);
        $.post(getAjaxUrl(), {
            action: 'daybooster_remove_completed_program',
            nonce: nonce,
            key: key
        })
            .done(function (res) {
                if (typeof res === 'string') {
                    try {
                        res = JSON.parse(res);
                    } catch (err) {
                        res = {};
                    }
                }
                if (res && res.success) {
                    const $li = $btn.closest('.cabinet_stats__completed-programs-item');
                    const $ul = $btn.closest('.cabinet_stats__completed-programs-list');
                    $li.remove();
                    if ($ul.length && $ul.children().length === 0) {
                        const emptyMsg = ($section.length && $section.data('emptyCompletedMsg'))
                            ? String($section.data('emptyCompletedMsg'))
                            : 'Пока нет завершённых программ.';
                        $ul.replaceWith($('<p></p>', { 'class': 'cabinet_stats__completed-programs-empty', text: emptyMsg }));
                    }
                    showAlert(res.message || '', 'success');
                } else {
                    showAlert((res && res.message) ? res.message : 'Ошибка.', 'error');
                    $btn.prop('disabled', false);
                }
            })
            .fail(function () {
                showAlert('Ошибка сети.', 'error');
                $btn.prop('disabled', false);
            });
    });

    (function initReviewSliders() {
        function bindHorizontalSlider(root, viewportSel, prevSel, nextSel, cardSelector, trackSelector) {
            const viewport = root.querySelector(viewportSel);
            const prev = root.querySelector(prevSel);
            const next = root.querySelector(nextSel);
            if (!viewport || !prev || !next) {
                return;
            }

            function getStep() {
                const card = viewport.querySelector(cardSelector);
                if (!card) {
                    return Math.max(120, Math.round(viewport.clientWidth * 0.5));
                }
                const track = viewport.querySelector(trackSelector);
                let g = 14;
                if (track) {
                    const cs = window.getComputedStyle(track);
                    const gap = cs.gap || cs.columnGap;
                    const parsed = parseFloat(gap);
                    if (Number.isFinite(parsed)) {
                        g = parsed;
                    }
                }
                return Math.round(card.getBoundingClientRect().width + g);
            }

            function updateNavDisabled() {
                const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth - 1);
                const x = viewport.scrollLeft;
                prev.disabled = x <= 1;
                next.disabled = x >= maxScroll - 1;
            }

            prev.addEventListener('click', function () {
                viewport.scrollBy({ left: -getStep(), behavior: 'smooth' });
            });
            next.addEventListener('click', function () {
                viewport.scrollBy({ left: getStep(), behavior: 'smooth' });
            });
            viewport.addEventListener('scroll', updateNavDisabled, { passive: true });
            window.addEventListener('resize', updateNavDisabled);
            updateNavDisabled();
        }

        document.querySelectorAll('[data-db-prog-reviews]').forEach(function (root) {
            bindHorizontalSlider(
                root,
                '[data-db-prog-reviews-viewport]',
                '[data-db-prog-reviews-prev]',
                '[data-db-prog-reviews-next]',
                '.db-prog-review-card',
                '.db-prog-reviews__track'
            );
        });

        document.querySelectorAll('[data-db-reviews]').forEach(function (root) {
            bindHorizontalSlider(
                root,
                '[data-db-reviews-viewport]',
                '[data-db-reviews-prev]',
                '[data-db-reviews-next]',
                '.db-review-card',
                '.db-reviews__track'
            );
        });
    })();

    (function initCabinetSettingsTabs() {
        var root = document.querySelector('.cabinet_settings--tabs');
        if (!root) {
            return;
        }
        var tabButtons = root.querySelectorAll('.cabinet_settings_tabs_nav [role="tab"]');
        var panels = root.querySelectorAll('.cabinet_settings_tabpanel');
        if (!tabButtons.length || !panels.length) {
            return;
        }

        function activate(tabId) {
            tabId = tabId || '';
            // Backward compatibility: old hash #cabinet-tab-profile now means "main".
            if (tabId === 'profile') {
                tabId = 'main';
            }
            if (!root.querySelector('#cabinet-tab-' + tabId)) {
                var firstTab = tabButtons[0] ? tabButtons[0].getAttribute('data-tab') : 'main';
                tabId = firstTab || 'main';
            }
            tabButtons.forEach(function (btn) {
                var id = btn.getAttribute('data-tab');
                var on = id === tabId;
                btn.setAttribute('aria-selected', on ? 'true' : 'false');
                btn.tabIndex = on ? 0 : -1;
            });
            panels.forEach(function (panel) {
                var match = panel.id === 'cabinet-tab-' + tabId;
                panel.hidden = !match;
                panel.classList.toggle('is-active', match);
            });
            try {
                history.replaceState(null, '', window.location.pathname + window.location.search + '#cabinet-tab-' + tabId);
            } catch (e) { /* ignore */ }
        }

        tabButtons.forEach(function (btn) {
            btn.addEventListener('click', function () {
                activate(btn.getAttribute('data-tab'));
            });
        });

        var hash = (window.location.hash || '').replace(/^#/, '');
        var activated = false;
        if (hash.indexOf('cabinet-tab-') === 0) {
            var fromHash = hash.replace('cabinet-tab-', '');
            if (fromHash === 'profile') {
                fromHash = 'main';
            }
            if (fromHash && root.querySelector('#cabinet-tab-' + fromHash)) {
                activate(fromHash);
                activated = true;
            }
        }
        if (!activated) {
            var first = tabButtons[0] ? tabButtons[0].getAttribute('data-tab') : '';
            activate(first || 'main');
        }
    })();

    (function initTodayDashTabs() {
        var root = document.querySelector('.today-dash-tabs');
        if (!root) {
            return;
        }
        var tabButtons = root.querySelectorAll('.today-dash-tabs__nav [role="tab"]');
        var panels = root.querySelectorAll('.today-dash-tabs__panel');
        if (!tabButtons.length || !panels.length) {
            return;
        }

        function activate(tabId) {
            var exists = false;
            tabButtons.forEach(function (btn) {
                if (btn.getAttribute('data-tab') === tabId) {
                    exists = true;
                }
            });
            if (!exists) {
                tabId = tabButtons[0] ? tabButtons[0].getAttribute('data-tab') : 'tasks';
            }
            tabButtons.forEach(function (btn) {
                var on = btn.getAttribute('data-tab') === tabId;
                btn.setAttribute('aria-selected', on ? 'true' : 'false');
                btn.tabIndex = on ? 0 : -1;
            });
            panels.forEach(function (panel) {
                var match = panel.getAttribute('data-tab') === tabId;
                panel.hidden = !match;
            });
            if (tabId === 'tasks') {
                window.requestAnimationFrame(function () {
                    window.dispatchEvent(new Event('resize'));
                });
            }
        }

        tabButtons.forEach(function (btn) {
            btn.addEventListener('click', function () {
                activate(btn.getAttribute('data-tab'));
            });
        });

        activate('tasks');
    })();

    //$(".wc-block-components-button").addClass('daybooster_btn');
});























